/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any }
  /** A calendar date in YYYY-MM-DD format. */
  Date: { input: any; output: any }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: any; output: any }
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: { input: any; output: any }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any }
}

export enum ActivitySupport {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum ActivitySupportList {
  Cleaning = 'CLEANING',
  CombingShaving = 'COMBING_SHAVING',
  Cooking = 'COOKING',
  DressingLowerBody = 'DRESSING_LOWER_BODY',
  DressingOther = 'DRESSING_OTHER',
  DressingUpperBody = 'DRESSING_UPPER_BODY',
  Drink = 'DRINK',
  Eat = 'EAT',
  ExcretionOther = 'EXCRETION_OTHER',
  FecalIncontinence = 'FECAL_INCONTINENCE',
  HairWash = 'HAIR_WASH',
  HousekeepingOther = 'HOUSEKEEPING_OTHER',
  HygieneOther = 'HYGIENE_OTHER',
  NutritionOther = 'NUTRITION_OTHER',
  OralCare = 'ORAL_CARE',
  Shopping = 'SHOPPING',
  Shower = 'SHOWER',
  Toilet = 'TOILET',
  UrinaryIncontinence = 'URINARY_INCONTINENCE',
  WashIntimateArea = 'WASH_INTIMATE_AREA',
  WashUpperBody = 'WASH_UPPER_BODY',
}

export type ActivitySupportPerson = {
  __typename?: 'ActivitySupportPerson'
  cleaning?: Maybe<Array<Maybe<Responsible>>>
  cleaningOtherComments?: Maybe<Scalars['String']['output']>
  combingShaving?: Maybe<Array<Maybe<Responsible>>>
  combingShavingOtherComments?: Maybe<Scalars['String']['output']>
  cooking?: Maybe<Array<Maybe<Responsible>>>
  cookingOtherComments?: Maybe<Scalars['String']['output']>
  dressingLowerBody?: Maybe<Array<Maybe<Responsible>>>
  dressingLowerBodyOtherComments?: Maybe<Scalars['String']['output']>
  dressingOther?: Maybe<Array<Maybe<Responsible>>>
  dressingOtherOtherComments?: Maybe<Scalars['String']['output']>
  dressingUpperBody?: Maybe<Array<Maybe<Responsible>>>
  dressingUpperBodyOtherComments?: Maybe<Scalars['String']['output']>
  drink?: Maybe<Array<Maybe<Responsible>>>
  drinkOtherComments?: Maybe<Scalars['String']['output']>
  eat?: Maybe<Array<Maybe<Responsible>>>
  eatOtherComments?: Maybe<Scalars['String']['output']>
  excretionOther?: Maybe<Array<Maybe<Responsible>>>
  excretionOtherOtherComments?: Maybe<Scalars['String']['output']>
  fecalIncontinence?: Maybe<Array<Maybe<Responsible>>>
  fecalIncontinenceOtherComments?: Maybe<Scalars['String']['output']>
  hairWash?: Maybe<Array<Maybe<Responsible>>>
  hairWashOtherComments?: Maybe<Scalars['String']['output']>
  housekeepingOther?: Maybe<Array<Maybe<Responsible>>>
  housekeepingOtherOtherComments?: Maybe<Scalars['String']['output']>
  hygieneOther?: Maybe<Array<Maybe<Responsible>>>
  hygieneOtherOtherComments?: Maybe<Scalars['String']['output']>
  nutritionOther?: Maybe<Array<Maybe<Responsible>>>
  nutritionOtherOtherComments?: Maybe<Scalars['String']['output']>
  oralCare?: Maybe<Array<Maybe<Responsible>>>
  oralCareOtherComments?: Maybe<Scalars['String']['output']>
  shopping?: Maybe<Array<Maybe<Responsible>>>
  shoppingOtherComments?: Maybe<Scalars['String']['output']>
  shower?: Maybe<Array<Maybe<Responsible>>>
  showerOtherComments?: Maybe<Scalars['String']['output']>
  toilet?: Maybe<Array<Maybe<Responsible>>>
  toiletOtherComments?: Maybe<Scalars['String']['output']>
  urinaryIncontinence?: Maybe<Array<Maybe<Responsible>>>
  urinaryIncontinenceOtherComments?: Maybe<Scalars['String']['output']>
  washIntimateArea?: Maybe<Array<Maybe<Responsible>>>
  washIntimateAreaOtherComments?: Maybe<Scalars['String']['output']>
  washUpperBody?: Maybe<Array<Maybe<Responsible>>>
  washUpperBodyOtherComments?: Maybe<Scalars['String']['output']>
}

/** An input for mutations affecting `ActivitySupportPerson` */
export type ActivitySupportPersonInput = {
  cleaning?: InputMaybe<Array<InputMaybe<Responsible>>>
  cleaningOtherComments?: InputMaybe<Scalars['String']['input']>
  combingShaving?: InputMaybe<Array<InputMaybe<Responsible>>>
  combingShavingOtherComments?: InputMaybe<Scalars['String']['input']>
  cooking?: InputMaybe<Array<InputMaybe<Responsible>>>
  cookingOtherComments?: InputMaybe<Scalars['String']['input']>
  dressingLowerBody?: InputMaybe<Array<InputMaybe<Responsible>>>
  dressingLowerBodyOtherComments?: InputMaybe<Scalars['String']['input']>
  dressingOther?: InputMaybe<Array<InputMaybe<Responsible>>>
  dressingOtherOtherComments?: InputMaybe<Scalars['String']['input']>
  dressingUpperBody?: InputMaybe<Array<InputMaybe<Responsible>>>
  dressingUpperBodyOtherComments?: InputMaybe<Scalars['String']['input']>
  drink?: InputMaybe<Array<InputMaybe<Responsible>>>
  drinkOtherComments?: InputMaybe<Scalars['String']['input']>
  eat?: InputMaybe<Array<InputMaybe<Responsible>>>
  eatOtherComments?: InputMaybe<Scalars['String']['input']>
  excretionOther?: InputMaybe<Array<InputMaybe<Responsible>>>
  excretionOtherOtherComments?: InputMaybe<Scalars['String']['input']>
  fecalIncontinence?: InputMaybe<Array<InputMaybe<Responsible>>>
  fecalIncontinenceOtherComments?: InputMaybe<Scalars['String']['input']>
  hairWash?: InputMaybe<Array<InputMaybe<Responsible>>>
  hairWashOtherComments?: InputMaybe<Scalars['String']['input']>
  housekeepingOther?: InputMaybe<Array<InputMaybe<Responsible>>>
  housekeepingOtherOtherComments?: InputMaybe<Scalars['String']['input']>
  hygieneOther?: InputMaybe<Array<InputMaybe<Responsible>>>
  hygieneOtherOtherComments?: InputMaybe<Scalars['String']['input']>
  nutritionOther?: InputMaybe<Array<InputMaybe<Responsible>>>
  nutritionOtherOtherComments?: InputMaybe<Scalars['String']['input']>
  oralCare?: InputMaybe<Array<InputMaybe<Responsible>>>
  oralCareOtherComments?: InputMaybe<Scalars['String']['input']>
  shopping?: InputMaybe<Array<InputMaybe<Responsible>>>
  shoppingOtherComments?: InputMaybe<Scalars['String']['input']>
  shower?: InputMaybe<Array<InputMaybe<Responsible>>>
  showerOtherComments?: InputMaybe<Scalars['String']['input']>
  toilet?: InputMaybe<Array<InputMaybe<Responsible>>>
  toiletOtherComments?: InputMaybe<Scalars['String']['input']>
  urinaryIncontinence?: InputMaybe<Array<InputMaybe<Responsible>>>
  urinaryIncontinenceOtherComments?: InputMaybe<Scalars['String']['input']>
  washIntimateArea?: InputMaybe<Array<InputMaybe<Responsible>>>
  washIntimateAreaOtherComments?: InputMaybe<Scalars['String']['input']>
  washUpperBody?: InputMaybe<Array<InputMaybe<Responsible>>>
  washUpperBodyOtherComments?: InputMaybe<Scalars['String']['input']>
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
}

/** An input for mutations affecting `Address` */
export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export type AppUser = Node & {
  __typename?: 'AppUser'
  /** Reads and enables pagination through a set of `AssessmentAdditionalInfo`. */
  assessmentAdditionalInfos: AssessmentAdditionalInfoConnection
  /** Reads and enables pagination through a set of `AssessmentDetail`. */
  assessmentDetails: AssessmentDetailConnection
  /** Reads and enables pagination through a set of `AssessmentMeasurement`. */
  assessmentMeasurements: AssessmentMeasurementConnection
  /** Reads and enables pagination through a set of `Assessment`. */
  assessments: AssessmentConnection
  /** Reads and enables pagination through a set of `Assignment`. */
  assignments: AssignmentConnection
  createdAt: Scalars['Datetime']['output']
  emailAddress: Scalars['String']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  lastLoginAt: Scalars['Datetime']['output']
  name: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
}

export type AppUserAssessmentAdditionalInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentAdditionalInfoCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentAdditionalInfoOrderBy>>
}

export type AppUserAssessmentDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentDetailCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentDetailOrderBy>>
}

export type AppUserAssessmentMeasurementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentMeasurementCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentMeasurementOrderBy>>
}

export type AppUserAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentOrderBy>>
}

export type AppUserAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssignmentCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssignmentOrderBy>>
}

/** A condition to be used against `AppUser` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AppUserCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `AppUser` values. */
export type AppUserConnection = {
  __typename?: 'AppUserConnection'
  /** A list of edges which contains the `AppUser` and cursor to aid in pagination. */
  edges: Array<Maybe<AppUserEdge>>
  /** A list of `AppUser` objects. */
  nodes: Array<Maybe<AppUser>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AppUser` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AppUser` edge in the connection. */
export type AppUserEdge = {
  __typename?: 'AppUserEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AppUser` at the end of the edge. */
  node?: Maybe<AppUser>
}

/** Methods to use when ordering `AppUser`. */
export enum AppUserOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

export type ArrayField = {
  __typename?: 'ArrayField'
  fieldName?: Maybe<Scalars['String']['output']>
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** An input for mutations affecting `ArrayField` */
export type ArrayFieldInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Assessment = Node & {
  __typename?: 'Assessment'
  /** Reads a single `AppUser` that is related to this `Assessment`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  /** Reads a single `AssessmentAdditionalInfo` that is related to this `Assessment`. */
  assessmentAdditionalInfo?: Maybe<AssessmentAdditionalInfo>
  /** Reads a single `AssessmentDetail` that is related to this `Assessment`. */
  assessmentDetail?: Maybe<AssessmentDetail>
  /** Reads a single `AssessmentMeasurement` that is related to this `Assessment`. */
  assessmentMeasurement?: Maybe<AssessmentMeasurement>
  /** Reads a single `AssessmentSignature` that is related to this `Assessment`. */
  assessmentSignature?: Maybe<AssessmentSignature>
  /** Reads a single `Assignment` that is related to this `Assessment`. */
  assignment?: Maybe<Assignment>
  assignmentId?: Maybe<Scalars['UUID']['output']>
  careServiceType?: Maybe<CareServiceType>
  caregiverRegistered?: Maybe<Scalars['String']['output']>
  consultationAt?: Maybe<Scalars['Date']['output']>
  consultationBeginAt?: Maybe<Scalars['Time']['output']>
  consultationEndAt?: Maybe<Scalars['Time']['output']>
  consultationParticipants?: Maybe<Array<Maybe<ConsultationParticipant>>>
  consultationParticipantsOther?: Maybe<Scalars['String']['output']>
  consultationReason?: Maybe<AssessmentConsultationReason>
  consultationReasonOther?: Maybe<Scalars['String']['output']>
  contactDaughterInLawSonInLaw?: Maybe<Contact>
  contactDaughterSon?: Maybe<Contact>
  contactFriend?: Maybe<Contact>
  contactGeneralPractitioner?: Maybe<Array<Maybe<Contact>>>
  contactGrandchild?: Maybe<Contact>
  contactNeighbor?: Maybe<Contact>
  contactNursingService?: Maybe<Contact>
  contactOther?: Maybe<Contact>
  contactParent?: Maybe<Contact>
  contactPartner?: Maybe<Contact>
  contactSpecialistDoctor?: Maybe<Array<Maybe<Contact>>>
  contactSupervisor?: Maybe<Contact>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  lifeForm?: Maybe<Array<Maybe<LifeForm>>>
  lifeFormOther?: Maybe<Scalars['String']['output']>
  medicalTreatment?: Maybe<Array<Maybe<MedicalTreatment>>>
  orders?: Maybe<Array<Maybe<Orders>>>
  patientAddress?: Maybe<Address>
  patientBirthdayAt?: Maybe<Scalars['Date']['output']>
  patientCareLevel?: Maybe<CareLevel>
  patientCareLevelNotes?: Maybe<Scalars['String']['output']>
  patientDiseases?: Maybe<Scalars['String']['output']>
  patientFinancialSituation?: Maybe<Scalars['String']['output']>
  patientGender?: Maybe<Gender>
  patientHasCareLevel?: Maybe<PatientHasCareLevel>
  patientId?: Maybe<Scalars['UUID']['output']>
  patientInsuranceName?: Maybe<Scalars['String']['output']>
  patientInsuranceNumber?: Maybe<Scalars['String']['output']>
  patientInsuranceType?: Maybe<Scalars['String']['output']>
  patientName?: Maybe<Scalars['String']['output']>
  patientPhoneNumber?: Maybe<Scalars['String']['output']>
  patientSurname?: Maybe<Scalars['String']['output']>
  patientTitle?: Maybe<Scalars['String']['output']>
  pushedAt: Scalars['Datetime']['output']
  relevantContacts?: Maybe<Array<Maybe<RelevantContacts>>>
  relevantContactsOther?: Maybe<Scalars['String']['output']>
  rowId: Scalars['UUID']['output']
  state: AssessmentState
  supportWithCare?: Maybe<Array<Maybe<SupportWithCare>>>
  supportWithCareOther?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
}

export type AssessmentAdditionalInfo = Node & {
  __typename?: 'AssessmentAdditionalInfo'
  agreedObjectives?: Maybe<Scalars['String']['output']>
  agreementsOnNextSteps?: Maybe<Scalars['String']['output']>
  /** Reads a single `AppUser` that is related to this `AssessmentAdditionalInfo`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  /** Reads a single `Assessment` that is related to this `AssessmentAdditionalInfo`. */
  assessment?: Maybe<Assessment>
  assessmentId?: Maybe<Scalars['UUID']['output']>
  billablePerson?: Maybe<ConsultationParticipant>
  careChangesSuggestionsPersonInNeedOfCare?: Maybe<Scalars['String']['output']>
  careChangesSuggestionsRelativeCaregiver?: Maybe<Scalars['String']['output']>
  careCounselingIndicatedSection7A?: Maybe<CareCounselingIndicatedSection7A>
  careCounselingRequestedSection7A?: Maybe<CareCounselingRequestedSection7A>
  careImprovementsSuggestionsPersonInNeedOfCare?: Maybe<
    Scalars['String']['output']
  >
  careImprovementsSuggestionsRelativeCaregiver?: Maybe<
    Scalars['String']['output']
  >
  consentToProcessingByInsuranceSection45?: Maybe<ConsentToProcessingByInsuranceSection45>
  consentToProcessingCounselingResultsSection7A?: Maybe<ConsentToProcessingCounselingResultsSection7A>
  consentToShareCareSupportInformation?: Maybe<ConsentToShareCareSupportInformation>
  consentToShareImprovementRecommendations?: Maybe<ConsentToShareImprovementRecommendations>
  consentToSiteInspectionAndToShareInformation?: Maybe<ConsentToSiteInspectionAndToShareInformation>
  counselingViaVideoConference?: Maybe<CounselingViaVideoConference>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  differentThanUsualPersonInNeedOfCare?: Maybe<Scalars['String']['output']>
  differentThanUsualRelativeCaregiver?: Maybe<Scalars['String']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  insuranceName?: Maybe<Scalars['String']['output']>
  locationAndDateSection373?: Maybe<Scalars['String']['output']>
  openQuestions?: Maybe<Scalars['String']['output']>
  otherCommentsPersonInNeedOfCare?: Maybe<Scalars['String']['output']>
  otherCommentsRelativeCaregiver?: Maybe<Scalars['String']['output']>
  protocolDispatch?: Maybe<ProtocolDispatch>
  protocolDispatchEmail?: Maybe<Scalars['String']['output']>
  pushedAt: Scalars['Datetime']['output']
  rowId: Scalars['UUID']['output']
  supportIsEnsured?: Maybe<AssessmentSupportIsEnsured>
  supportIsEnsuredReason?: Maybe<Scalars['String']['output']>
  supportSituationCaregiverPerspective?: Maybe<Scalars['String']['output']>
  supportSituationCounselorPerspective?: Maybe<Scalars['String']['output']>
  supportSituationImproveMeasures?: Maybe<SupportSituationImproveMeasures>
  supportSituationImproveMeasuresSuggestions?: Maybe<
    Array<Maybe<SupportSituationImproveMeasuresSuggestions>>
  >
  supportSituationImproveMeasuresSuggestionsOtherComments?: Maybe<
    Scalars['String']['output']
  >
  trainingSubject?: Maybe<TrainingSubjects>
  updatedAt: Scalars['Datetime']['output']
}

/**
 * A condition to be used against `AssessmentAdditionalInfo` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AssessmentAdditionalInfoCondition = {
  /** Checks for equality with the object’s `appUserId` field. */
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `AssessmentAdditionalInfo` values. */
export type AssessmentAdditionalInfoConnection = {
  __typename?: 'AssessmentAdditionalInfoConnection'
  /** A list of edges which contains the `AssessmentAdditionalInfo` and cursor to aid in pagination. */
  edges: Array<Maybe<AssessmentAdditionalInfoEdge>>
  /** A list of `AssessmentAdditionalInfo` objects. */
  nodes: Array<Maybe<AssessmentAdditionalInfo>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AssessmentAdditionalInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AssessmentAdditionalInfo` edge in the connection. */
export type AssessmentAdditionalInfoEdge = {
  __typename?: 'AssessmentAdditionalInfoEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AssessmentAdditionalInfo` at the end of the edge. */
  node?: Maybe<AssessmentAdditionalInfo>
}

/** An input for mutations affecting `AssessmentAdditionalInfo` */
export type AssessmentAdditionalInfoInput = {
  agreedObjectives?: InputMaybe<Scalars['String']['input']>
  agreementsOnNextSteps?: InputMaybe<Scalars['String']['input']>
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  billablePerson?: InputMaybe<ConsultationParticipant>
  careChangesSuggestionsPersonInNeedOfCare?: InputMaybe<
    Scalars['String']['input']
  >
  careChangesSuggestionsRelativeCaregiver?: InputMaybe<
    Scalars['String']['input']
  >
  careCounselingIndicatedSection7A?: InputMaybe<CareCounselingIndicatedSection7A>
  careCounselingRequestedSection7A?: InputMaybe<CareCounselingRequestedSection7A>
  careImprovementsSuggestionsPersonInNeedOfCare?: InputMaybe<
    Scalars['String']['input']
  >
  careImprovementsSuggestionsRelativeCaregiver?: InputMaybe<
    Scalars['String']['input']
  >
  consentToProcessingByInsuranceSection45?: InputMaybe<ConsentToProcessingByInsuranceSection45>
  consentToProcessingCounselingResultsSection7A?: InputMaybe<ConsentToProcessingCounselingResultsSection7A>
  consentToShareCareSupportInformation?: InputMaybe<ConsentToShareCareSupportInformation>
  consentToShareImprovementRecommendations?: InputMaybe<ConsentToShareImprovementRecommendations>
  consentToSiteInspectionAndToShareInformation?: InputMaybe<ConsentToSiteInspectionAndToShareInformation>
  counselingViaVideoConference?: InputMaybe<CounselingViaVideoConference>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  differentThanUsualPersonInNeedOfCare?: InputMaybe<Scalars['String']['input']>
  differentThanUsualRelativeCaregiver?: InputMaybe<Scalars['String']['input']>
  insuranceName?: InputMaybe<Scalars['String']['input']>
  locationAndDateSection373?: InputMaybe<Scalars['String']['input']>
  openQuestions?: InputMaybe<Scalars['String']['input']>
  otherCommentsPersonInNeedOfCare?: InputMaybe<Scalars['String']['input']>
  otherCommentsRelativeCaregiver?: InputMaybe<Scalars['String']['input']>
  protocolDispatch?: InputMaybe<ProtocolDispatch>
  protocolDispatchEmail?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  supportIsEnsured?: InputMaybe<AssessmentSupportIsEnsured>
  supportIsEnsuredReason?: InputMaybe<Scalars['String']['input']>
  supportSituationCaregiverPerspective?: InputMaybe<Scalars['String']['input']>
  supportSituationCounselorPerspective?: InputMaybe<Scalars['String']['input']>
  supportSituationImproveMeasures?: InputMaybe<SupportSituationImproveMeasures>
  supportSituationImproveMeasuresSuggestions?: InputMaybe<
    Array<InputMaybe<SupportSituationImproveMeasuresSuggestions>>
  >
  supportSituationImproveMeasuresSuggestionsOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  trainingSubject?: InputMaybe<TrainingSubjects>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Methods to use when ordering `AssessmentAdditionalInfo`. */
export enum AssessmentAdditionalInfoOrderBy {
  AppUserIdAsc = 'APP_USER_ID_ASC',
  AppUserIdDesc = 'APP_USER_ID_DESC',
  AssessmentIdAsc = 'ASSESSMENT_ID_ASC',
  AssessmentIdDesc = 'ASSESSMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `AssessmentAdditionalInfo`. Fields that are set will be updated. */
export type AssessmentAdditionalInfoPatch = {
  agreedObjectives?: InputMaybe<Scalars['String']['input']>
  agreementsOnNextSteps?: InputMaybe<Scalars['String']['input']>
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  billablePerson?: InputMaybe<ConsultationParticipant>
  careChangesSuggestionsPersonInNeedOfCare?: InputMaybe<
    Scalars['String']['input']
  >
  careChangesSuggestionsRelativeCaregiver?: InputMaybe<
    Scalars['String']['input']
  >
  careCounselingIndicatedSection7A?: InputMaybe<CareCounselingIndicatedSection7A>
  careCounselingRequestedSection7A?: InputMaybe<CareCounselingRequestedSection7A>
  careImprovementsSuggestionsPersonInNeedOfCare?: InputMaybe<
    Scalars['String']['input']
  >
  careImprovementsSuggestionsRelativeCaregiver?: InputMaybe<
    Scalars['String']['input']
  >
  consentToProcessingByInsuranceSection45?: InputMaybe<ConsentToProcessingByInsuranceSection45>
  consentToProcessingCounselingResultsSection7A?: InputMaybe<ConsentToProcessingCounselingResultsSection7A>
  consentToShareCareSupportInformation?: InputMaybe<ConsentToShareCareSupportInformation>
  consentToShareImprovementRecommendations?: InputMaybe<ConsentToShareImprovementRecommendations>
  consentToSiteInspectionAndToShareInformation?: InputMaybe<ConsentToSiteInspectionAndToShareInformation>
  counselingViaVideoConference?: InputMaybe<CounselingViaVideoConference>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  differentThanUsualPersonInNeedOfCare?: InputMaybe<Scalars['String']['input']>
  differentThanUsualRelativeCaregiver?: InputMaybe<Scalars['String']['input']>
  insuranceName?: InputMaybe<Scalars['String']['input']>
  locationAndDateSection373?: InputMaybe<Scalars['String']['input']>
  openQuestions?: InputMaybe<Scalars['String']['input']>
  otherCommentsPersonInNeedOfCare?: InputMaybe<Scalars['String']['input']>
  otherCommentsRelativeCaregiver?: InputMaybe<Scalars['String']['input']>
  protocolDispatch?: InputMaybe<ProtocolDispatch>
  protocolDispatchEmail?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  supportIsEnsured?: InputMaybe<AssessmentSupportIsEnsured>
  supportIsEnsuredReason?: InputMaybe<Scalars['String']['input']>
  supportSituationCaregiverPerspective?: InputMaybe<Scalars['String']['input']>
  supportSituationCounselorPerspective?: InputMaybe<Scalars['String']['input']>
  supportSituationImproveMeasures?: InputMaybe<SupportSituationImproveMeasures>
  supportSituationImproveMeasuresSuggestions?: InputMaybe<
    Array<InputMaybe<SupportSituationImproveMeasuresSuggestions>>
  >
  supportSituationImproveMeasuresSuggestionsOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  trainingSubject?: InputMaybe<TrainingSubjects>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** All input for the `assessmentAdditionalInfoReplicate` mutation. */
export type AssessmentAdditionalInfoReplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<AssessmentAdditionalInfoInput>>>
}

/** The output of our `assessmentAdditionalInfoReplicate` mutation. */
export type AssessmentAdditionalInfoReplicatePayload = {
  __typename?: 'AssessmentAdditionalInfoReplicatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<Array<Maybe<AssessmentAdditionalInfo>>>
}

export type AssessmentAdditionalInfoSubscriptionPayload = {
  __typename?: 'AssessmentAdditionalInfoSubscriptionPayload'
  assessmentAdditionalInfo?: Maybe<AssessmentAdditionalInfo>
  event?: Maybe<Scalars['String']['output']>
}

/**
 * A condition to be used against `Assessment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AssessmentCondition = {
  /** Checks for equality with the object’s `appUserId` field. */
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `assignmentId` field. */
  assignmentId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `Assessment` values. */
export type AssessmentConnection = {
  __typename?: 'AssessmentConnection'
  /** A list of edges which contains the `Assessment` and cursor to aid in pagination. */
  edges: Array<Maybe<AssessmentEdge>>
  /** A list of `Assessment` objects. */
  nodes: Array<Maybe<Assessment>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Assessment` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

export enum AssessmentConsultationReason {
  Other = 'OTHER',
  Par_7A = 'PAR_7A',
  Par_37_3 = 'PAR_37_3',
  Par_45 = 'PAR_45',
}

export type AssessmentDetail = Node & {
  __typename?: 'AssessmentDetail'
  activitySupport?: Maybe<ActivitySupport>
  activitySupportList?: Maybe<Array<Maybe<ActivitySupportList>>>
  activitySupportListDressingOtherComments?: Maybe<Scalars['String']['output']>
  activitySupportListExcretionOtherComments?: Maybe<Scalars['String']['output']>
  activitySupportListHousekeepingOtherComments?: Maybe<
    Scalars['String']['output']
  >
  activitySupportListHygieneOtherComments?: Maybe<Scalars['String']['output']>
  activitySupportListNutritionOtherComments?: Maybe<Scalars['String']['output']>
  activitySupportPerson?: Maybe<ActivitySupportPerson>
  /** Reads a single `AppUser` that is related to this `AssessmentDetail`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  /** Reads a single `Assessment` that is related to this `AssessmentDetail`. */
  assessment?: Maybe<Assessment>
  assessmentId?: Maybe<Scalars['UUID']['output']>
  assistanceNeeded?: Maybe<AssistanceNeeded>
  assistanceServices?: Maybe<Array<Maybe<AssistanceService>>>
  assistanceServicesNeeded?: Maybe<AssistanceServiceNeeded>
  assistanceServicesOtherComments?: Maybe<Scalars['String']['output']>
  assistances?: Maybe<Array<Maybe<Assistance>>>
  assistancesDevicesToFoodIntakeComments?: Maybe<Scalars['String']['output']>
  assistancesDevicesToSupportExcretionComments?: Maybe<
    Scalars['String']['output']
  >
  assistancesMobilityComments?: Maybe<Scalars['String']['output']>
  assistancesOtherComments?: Maybe<Scalars['String']['output']>
  assistancesPersonalHygieneComments?: Maybe<Scalars['String']['output']>
  assistancesPhysicalAidComments?: Maybe<Scalars['String']['output']>
  assistancesPositioningInBedComments?: Maybe<Scalars['String']['output']>
  behaviorChanges?: Maybe<BehaviorChanges>
  behaviorChangesList?: Maybe<Array<Maybe<BehaviorChangesList>>>
  behaviorChangesListOtherComments?: Maybe<Scalars['String']['output']>
  careIssues?: Maybe<CareIssues>
  careRelationshipAdvice?: Maybe<CareRelationshipAdvice>
  careRelationshipAdviceComments?: Maybe<Scalars['String']['output']>
  careRelationshipAdviceTopics?: Maybe<Scalars['String']['output']>
  careSituation?: Maybe<CareSituation>
  careWellOrganized?: Maybe<CareWellOrganized>
  changesSupportNeeded?: Maybe<ChangesSupportNeeded>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  depressedRecently?: Maybe<DepressedRecently>
  diseaseMeasures?: Maybe<DiseaseMeasures>
  diseaseMeasuresList?: Maybe<Array<Maybe<DiseaseMeasuresList>>>
  diseaseMeasuresListOtherComments?: Maybe<Scalars['String']['output']>
  diseaseMeasuresResponsible?: Maybe<MeasureResponsible>
  fallenCareRecently?: Maybe<FallenCareRecently>
  generallyPhysicalActive?: Maybe<GenerallyPhysicalActive>
  hospitalizedRecently?: Maybe<HospitalizedRecently>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  lessEnjoyment?: Maybe<LessEnjoyment>
  livingEnvironmentAdvice?: Maybe<LivingEnvironmentAdvice>
  livingEnvironmentAdviceComments?: Maybe<Scalars['String']['output']>
  livingEnvironmentAdviceTopics?: Maybe<Scalars['String']['output']>
  livingEnvironmentProblems?: Maybe<LivingEnvironmentProblems>
  livingEnvironmentProblemsList?: Maybe<
    Array<Maybe<LivingEnvironmentProblemsList>>
  >
  livingEnvironmentProblemsListOtherComments?: Maybe<
    Scalars['String']['output']
  >
  livingEnvironmentSupport?: Maybe<LivingEnvironmentSupport>
  mentalDifficulties?: Maybe<MentalDifficulties>
  mentalDifficultiesList?: Maybe<Array<Maybe<MentalDifficultiesList>>>
  mentalDifficultiesListOtherComments?: Maybe<Scalars['String']['output']>
  mentalHealthCounseling?: Maybe<MentalHealthCounseling>
  mentalHealthCounselingComments?: Maybe<Scalars['String']['output']>
  mentalHealthCounselingTopics?: Maybe<Scalars['String']['output']>
  mobilityAreaAdvice?: Maybe<MobilityAreaAdvice>
  mobilityAreaAdviceComments?: Maybe<Scalars['String']['output']>
  mobilityAreaAdviceTopics?: Maybe<Scalars['String']['output']>
  movingDifficulties?: Maybe<MovingDifficulties>
  movingDifficultiesActivity?: Maybe<Array<Maybe<MovingDifficultiesActivity>>>
  movingDifficultiesActivityOtherComments?: Maybe<Scalars['String']['output']>
  organizationCareAdviceComments?: Maybe<Scalars['String']['output']>
  organizationCareAdviceNeeded?: Maybe<OrganizationCareAdviceNeeded>
  organizationCareAdviceTopics?: Maybe<Scalars['String']['output']>
  otherAssistancesNeeded?: Maybe<OtherAssistanceNeeded>
  otherAssistancesService?: Maybe<Array<Maybe<OtherAssistanceService>>>
  otherAssistancesServiceOtherComments?: Maybe<Scalars['String']['output']>
  physicalHealthAdvice?: Maybe<PhysicalHealthAdvice>
  physicalHealthAdviceComments?: Maybe<Scalars['String']['output']>
  physicalHealthAdviceTopics?: Maybe<Scalars['String']['output']>
  physicalProblems?: Maybe<PhysicalProblems>
  physicalProblemsList?: Maybe<Array<Maybe<PhysicalProblemsList>>>
  physicalProblemsListOtherComments?: Maybe<Scalars['String']['output']>
  pushedAt: Scalars['Datetime']['output']
  relationshipIssues?: Maybe<RelationshipIssues>
  relativesCareAdvice?: Maybe<RelativesCareAdvice>
  relativesCareAdviceComments?: Maybe<Scalars['String']['output']>
  relativesCareAdviceTopics?: Maybe<Scalars['String']['output']>
  relativesCareDifficultiesList?: Maybe<
    Array<Maybe<RelativesCareDifficultiesList>>
  >
  relativesCareDifficultiesListOtherComments?: Maybe<
    Scalars['String']['output']
  >
  relativesCareHelpFactorsList?: Maybe<
    Array<Maybe<RelativesCareHelpFactorsList>>
  >
  relativesCareHelpFactorsListOtherComments?: Maybe<Scalars['String']['output']>
  relativesIssues?: Maybe<RelativesIssues>
  relativesRelationshipIssues?: Maybe<RelativesRelationshipIssues>
  reportingResponsible?: Maybe<ReportingResponsible>
  rowId: Scalars['UUID']['output']
  selfSufficiencyAdvice?: Maybe<SelfSufficiencyAdvice>
  selfSufficiencyAdviceComments?: Maybe<Scalars['String']['output']>
  selfSufficiencyAdviceTopics?: Maybe<Scalars['String']['output']>
  signsOfHealthRisk?: Maybe<SignsOfHealthRisk>
  signsOfHealthRiskList?: Maybe<Array<Maybe<SignsOfHealthRiskList>>>
  signsOfHealthRiskListSpecificRisksComments?: Maybe<
    Scalars['String']['output']
  >
  socialContactAdvice?: Maybe<SocialContactAdvice>
  socialContactAdviceComments?: Maybe<Scalars['String']['output']>
  socialContactAdviceTopics?: Maybe<Scalars['String']['output']>
  socialContactDifficulties?: Maybe<SocialContactDifficulties>
  socialContactDifficultiesList?: Maybe<
    Array<Maybe<SocialContactDifficultiesList>>
  >
  socialContactDifficultiesListOtherComments?: Maybe<
    Scalars['String']['output']
  >
  socialContactSupport?: Maybe<SocialContactSupport>
  sufficientActivitiesSupport?: Maybe<SufficientActivitiesSupport>
  sufficientMovingCare?: Maybe<SufficientMovingCare>
  sufficientProblemsSupport?: Maybe<SufficientProblemsSupport>
  therapies?: Maybe<Array<Maybe<Therapy>>>
  therapiesNeeded?: Maybe<TherapyNeeded>
  therapiesOtherComments?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  withRelativesIssues?: Maybe<WithRelativesIssues>
  withRelativesIssuesPersonInNeed?: Maybe<WithRelativesIssuesPersonInNeed>
}

/**
 * A condition to be used against `AssessmentDetail` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AssessmentDetailCondition = {
  /** Checks for equality with the object’s `appUserId` field. */
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `AssessmentDetail` values. */
export type AssessmentDetailConnection = {
  __typename?: 'AssessmentDetailConnection'
  /** A list of edges which contains the `AssessmentDetail` and cursor to aid in pagination. */
  edges: Array<Maybe<AssessmentDetailEdge>>
  /** A list of `AssessmentDetail` objects. */
  nodes: Array<Maybe<AssessmentDetail>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AssessmentDetail` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AssessmentDetail` edge in the connection. */
export type AssessmentDetailEdge = {
  __typename?: 'AssessmentDetailEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AssessmentDetail` at the end of the edge. */
  node?: Maybe<AssessmentDetail>
}

/** An input for mutations affecting `AssessmentDetail` */
export type AssessmentDetailInput = {
  activitySupport?: InputMaybe<ActivitySupport>
  activitySupportList?: InputMaybe<Array<InputMaybe<ActivitySupportList>>>
  activitySupportListDressingOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListExcretionOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListHousekeepingOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListHygieneOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListNutritionOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportPerson?: InputMaybe<ActivitySupportPersonInput>
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  assistanceNeeded?: InputMaybe<AssistanceNeeded>
  assistanceServices?: InputMaybe<Array<InputMaybe<AssistanceService>>>
  assistanceServicesNeeded?: InputMaybe<AssistanceServiceNeeded>
  assistanceServicesOtherComments?: InputMaybe<Scalars['String']['input']>
  assistances?: InputMaybe<Array<InputMaybe<Assistance>>>
  assistancesDevicesToFoodIntakeComments?: InputMaybe<
    Scalars['String']['input']
  >
  assistancesDevicesToSupportExcretionComments?: InputMaybe<
    Scalars['String']['input']
  >
  assistancesMobilityComments?: InputMaybe<Scalars['String']['input']>
  assistancesOtherComments?: InputMaybe<Scalars['String']['input']>
  assistancesPersonalHygieneComments?: InputMaybe<Scalars['String']['input']>
  assistancesPhysicalAidComments?: InputMaybe<Scalars['String']['input']>
  assistancesPositioningInBedComments?: InputMaybe<Scalars['String']['input']>
  behaviorChanges?: InputMaybe<BehaviorChanges>
  behaviorChangesList?: InputMaybe<Array<InputMaybe<BehaviorChangesList>>>
  behaviorChangesListOtherComments?: InputMaybe<Scalars['String']['input']>
  careIssues?: InputMaybe<CareIssues>
  careRelationshipAdvice?: InputMaybe<CareRelationshipAdvice>
  careRelationshipAdviceComments?: InputMaybe<Scalars['String']['input']>
  careRelationshipAdviceTopics?: InputMaybe<Scalars['String']['input']>
  careSituation?: InputMaybe<CareSituation>
  careWellOrganized?: InputMaybe<CareWellOrganized>
  changesSupportNeeded?: InputMaybe<ChangesSupportNeeded>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  depressedRecently?: InputMaybe<DepressedRecently>
  diseaseMeasures?: InputMaybe<DiseaseMeasures>
  diseaseMeasuresList?: InputMaybe<Array<InputMaybe<DiseaseMeasuresList>>>
  diseaseMeasuresListOtherComments?: InputMaybe<Scalars['String']['input']>
  diseaseMeasuresResponsible?: InputMaybe<MeasureResponsibleInput>
  fallenCareRecently?: InputMaybe<FallenCareRecently>
  generallyPhysicalActive?: InputMaybe<GenerallyPhysicalActive>
  hospitalizedRecently?: InputMaybe<HospitalizedRecently>
  lessEnjoyment?: InputMaybe<LessEnjoyment>
  livingEnvironmentAdvice?: InputMaybe<LivingEnvironmentAdvice>
  livingEnvironmentAdviceComments?: InputMaybe<Scalars['String']['input']>
  livingEnvironmentAdviceTopics?: InputMaybe<Scalars['String']['input']>
  livingEnvironmentProblems?: InputMaybe<LivingEnvironmentProblems>
  livingEnvironmentProblemsList?: InputMaybe<
    Array<InputMaybe<LivingEnvironmentProblemsList>>
  >
  livingEnvironmentProblemsListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  livingEnvironmentSupport?: InputMaybe<LivingEnvironmentSupport>
  mentalDifficulties?: InputMaybe<MentalDifficulties>
  mentalDifficultiesList?: InputMaybe<Array<InputMaybe<MentalDifficultiesList>>>
  mentalDifficultiesListOtherComments?: InputMaybe<Scalars['String']['input']>
  mentalHealthCounseling?: InputMaybe<MentalHealthCounseling>
  mentalHealthCounselingComments?: InputMaybe<Scalars['String']['input']>
  mentalHealthCounselingTopics?: InputMaybe<Scalars['String']['input']>
  mobilityAreaAdvice?: InputMaybe<MobilityAreaAdvice>
  mobilityAreaAdviceComments?: InputMaybe<Scalars['String']['input']>
  mobilityAreaAdviceTopics?: InputMaybe<Scalars['String']['input']>
  movingDifficulties?: InputMaybe<MovingDifficulties>
  movingDifficultiesActivity?: InputMaybe<
    Array<InputMaybe<MovingDifficultiesActivity>>
  >
  movingDifficultiesActivityOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  organizationCareAdviceComments?: InputMaybe<Scalars['String']['input']>
  organizationCareAdviceNeeded?: InputMaybe<OrganizationCareAdviceNeeded>
  organizationCareAdviceTopics?: InputMaybe<Scalars['String']['input']>
  otherAssistancesNeeded?: InputMaybe<OtherAssistanceNeeded>
  otherAssistancesService?: InputMaybe<
    Array<InputMaybe<OtherAssistanceService>>
  >
  otherAssistancesServiceOtherComments?: InputMaybe<Scalars['String']['input']>
  physicalHealthAdvice?: InputMaybe<PhysicalHealthAdvice>
  physicalHealthAdviceComments?: InputMaybe<Scalars['String']['input']>
  physicalHealthAdviceTopics?: InputMaybe<Scalars['String']['input']>
  physicalProblems?: InputMaybe<PhysicalProblems>
  physicalProblemsList?: InputMaybe<Array<InputMaybe<PhysicalProblemsList>>>
  physicalProblemsListOtherComments?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relationshipIssues?: InputMaybe<RelationshipIssues>
  relativesCareAdvice?: InputMaybe<RelativesCareAdvice>
  relativesCareAdviceComments?: InputMaybe<Scalars['String']['input']>
  relativesCareAdviceTopics?: InputMaybe<Scalars['String']['input']>
  relativesCareDifficultiesList?: InputMaybe<
    Array<InputMaybe<RelativesCareDifficultiesList>>
  >
  relativesCareDifficultiesListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  relativesCareHelpFactorsList?: InputMaybe<
    Array<InputMaybe<RelativesCareHelpFactorsList>>
  >
  relativesCareHelpFactorsListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  relativesIssues?: InputMaybe<RelativesIssues>
  relativesRelationshipIssues?: InputMaybe<RelativesRelationshipIssues>
  reportingResponsible?: InputMaybe<ReportingResponsible>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selfSufficiencyAdvice?: InputMaybe<SelfSufficiencyAdvice>
  selfSufficiencyAdviceComments?: InputMaybe<Scalars['String']['input']>
  selfSufficiencyAdviceTopics?: InputMaybe<Scalars['String']['input']>
  signsOfHealthRisk?: InputMaybe<SignsOfHealthRisk>
  signsOfHealthRiskList?: InputMaybe<Array<InputMaybe<SignsOfHealthRiskList>>>
  signsOfHealthRiskListSpecificRisksComments?: InputMaybe<
    Scalars['String']['input']
  >
  socialContactAdvice?: InputMaybe<SocialContactAdvice>
  socialContactAdviceComments?: InputMaybe<Scalars['String']['input']>
  socialContactAdviceTopics?: InputMaybe<Scalars['String']['input']>
  socialContactDifficulties?: InputMaybe<SocialContactDifficulties>
  socialContactDifficultiesList?: InputMaybe<
    Array<InputMaybe<SocialContactDifficultiesList>>
  >
  socialContactDifficultiesListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  socialContactSupport?: InputMaybe<SocialContactSupport>
  sufficientActivitiesSupport?: InputMaybe<SufficientActivitiesSupport>
  sufficientMovingCare?: InputMaybe<SufficientMovingCare>
  sufficientProblemsSupport?: InputMaybe<SufficientProblemsSupport>
  therapies?: InputMaybe<Array<InputMaybe<Therapy>>>
  therapiesNeeded?: InputMaybe<TherapyNeeded>
  therapiesOtherComments?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  withRelativesIssues?: InputMaybe<WithRelativesIssues>
  withRelativesIssuesPersonInNeed?: InputMaybe<WithRelativesIssuesPersonInNeed>
}

/** Methods to use when ordering `AssessmentDetail`. */
export enum AssessmentDetailOrderBy {
  AppUserIdAsc = 'APP_USER_ID_ASC',
  AppUserIdDesc = 'APP_USER_ID_DESC',
  AssessmentIdAsc = 'ASSESSMENT_ID_ASC',
  AssessmentIdDesc = 'ASSESSMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `AssessmentDetail`. Fields that are set will be updated. */
export type AssessmentDetailPatch = {
  activitySupport?: InputMaybe<ActivitySupport>
  activitySupportList?: InputMaybe<Array<InputMaybe<ActivitySupportList>>>
  activitySupportListDressingOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListExcretionOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListHousekeepingOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListHygieneOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportListNutritionOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  activitySupportPerson?: InputMaybe<ActivitySupportPersonInput>
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  assistanceNeeded?: InputMaybe<AssistanceNeeded>
  assistanceServices?: InputMaybe<Array<InputMaybe<AssistanceService>>>
  assistanceServicesNeeded?: InputMaybe<AssistanceServiceNeeded>
  assistanceServicesOtherComments?: InputMaybe<Scalars['String']['input']>
  assistances?: InputMaybe<Array<InputMaybe<Assistance>>>
  assistancesDevicesToFoodIntakeComments?: InputMaybe<
    Scalars['String']['input']
  >
  assistancesDevicesToSupportExcretionComments?: InputMaybe<
    Scalars['String']['input']
  >
  assistancesMobilityComments?: InputMaybe<Scalars['String']['input']>
  assistancesOtherComments?: InputMaybe<Scalars['String']['input']>
  assistancesPersonalHygieneComments?: InputMaybe<Scalars['String']['input']>
  assistancesPhysicalAidComments?: InputMaybe<Scalars['String']['input']>
  assistancesPositioningInBedComments?: InputMaybe<Scalars['String']['input']>
  behaviorChanges?: InputMaybe<BehaviorChanges>
  behaviorChangesList?: InputMaybe<Array<InputMaybe<BehaviorChangesList>>>
  behaviorChangesListOtherComments?: InputMaybe<Scalars['String']['input']>
  careIssues?: InputMaybe<CareIssues>
  careRelationshipAdvice?: InputMaybe<CareRelationshipAdvice>
  careRelationshipAdviceComments?: InputMaybe<Scalars['String']['input']>
  careRelationshipAdviceTopics?: InputMaybe<Scalars['String']['input']>
  careSituation?: InputMaybe<CareSituation>
  careWellOrganized?: InputMaybe<CareWellOrganized>
  changesSupportNeeded?: InputMaybe<ChangesSupportNeeded>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  depressedRecently?: InputMaybe<DepressedRecently>
  diseaseMeasures?: InputMaybe<DiseaseMeasures>
  diseaseMeasuresList?: InputMaybe<Array<InputMaybe<DiseaseMeasuresList>>>
  diseaseMeasuresListOtherComments?: InputMaybe<Scalars['String']['input']>
  diseaseMeasuresResponsible?: InputMaybe<MeasureResponsibleInput>
  fallenCareRecently?: InputMaybe<FallenCareRecently>
  generallyPhysicalActive?: InputMaybe<GenerallyPhysicalActive>
  hospitalizedRecently?: InputMaybe<HospitalizedRecently>
  lessEnjoyment?: InputMaybe<LessEnjoyment>
  livingEnvironmentAdvice?: InputMaybe<LivingEnvironmentAdvice>
  livingEnvironmentAdviceComments?: InputMaybe<Scalars['String']['input']>
  livingEnvironmentAdviceTopics?: InputMaybe<Scalars['String']['input']>
  livingEnvironmentProblems?: InputMaybe<LivingEnvironmentProblems>
  livingEnvironmentProblemsList?: InputMaybe<
    Array<InputMaybe<LivingEnvironmentProblemsList>>
  >
  livingEnvironmentProblemsListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  livingEnvironmentSupport?: InputMaybe<LivingEnvironmentSupport>
  mentalDifficulties?: InputMaybe<MentalDifficulties>
  mentalDifficultiesList?: InputMaybe<Array<InputMaybe<MentalDifficultiesList>>>
  mentalDifficultiesListOtherComments?: InputMaybe<Scalars['String']['input']>
  mentalHealthCounseling?: InputMaybe<MentalHealthCounseling>
  mentalHealthCounselingComments?: InputMaybe<Scalars['String']['input']>
  mentalHealthCounselingTopics?: InputMaybe<Scalars['String']['input']>
  mobilityAreaAdvice?: InputMaybe<MobilityAreaAdvice>
  mobilityAreaAdviceComments?: InputMaybe<Scalars['String']['input']>
  mobilityAreaAdviceTopics?: InputMaybe<Scalars['String']['input']>
  movingDifficulties?: InputMaybe<MovingDifficulties>
  movingDifficultiesActivity?: InputMaybe<
    Array<InputMaybe<MovingDifficultiesActivity>>
  >
  movingDifficultiesActivityOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  organizationCareAdviceComments?: InputMaybe<Scalars['String']['input']>
  organizationCareAdviceNeeded?: InputMaybe<OrganizationCareAdviceNeeded>
  organizationCareAdviceTopics?: InputMaybe<Scalars['String']['input']>
  otherAssistancesNeeded?: InputMaybe<OtherAssistanceNeeded>
  otherAssistancesService?: InputMaybe<
    Array<InputMaybe<OtherAssistanceService>>
  >
  otherAssistancesServiceOtherComments?: InputMaybe<Scalars['String']['input']>
  physicalHealthAdvice?: InputMaybe<PhysicalHealthAdvice>
  physicalHealthAdviceComments?: InputMaybe<Scalars['String']['input']>
  physicalHealthAdviceTopics?: InputMaybe<Scalars['String']['input']>
  physicalProblems?: InputMaybe<PhysicalProblems>
  physicalProblemsList?: InputMaybe<Array<InputMaybe<PhysicalProblemsList>>>
  physicalProblemsListOtherComments?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relationshipIssues?: InputMaybe<RelationshipIssues>
  relativesCareAdvice?: InputMaybe<RelativesCareAdvice>
  relativesCareAdviceComments?: InputMaybe<Scalars['String']['input']>
  relativesCareAdviceTopics?: InputMaybe<Scalars['String']['input']>
  relativesCareDifficultiesList?: InputMaybe<
    Array<InputMaybe<RelativesCareDifficultiesList>>
  >
  relativesCareDifficultiesListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  relativesCareHelpFactorsList?: InputMaybe<
    Array<InputMaybe<RelativesCareHelpFactorsList>>
  >
  relativesCareHelpFactorsListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  relativesIssues?: InputMaybe<RelativesIssues>
  relativesRelationshipIssues?: InputMaybe<RelativesRelationshipIssues>
  reportingResponsible?: InputMaybe<ReportingResponsible>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selfSufficiencyAdvice?: InputMaybe<SelfSufficiencyAdvice>
  selfSufficiencyAdviceComments?: InputMaybe<Scalars['String']['input']>
  selfSufficiencyAdviceTopics?: InputMaybe<Scalars['String']['input']>
  signsOfHealthRisk?: InputMaybe<SignsOfHealthRisk>
  signsOfHealthRiskList?: InputMaybe<Array<InputMaybe<SignsOfHealthRiskList>>>
  signsOfHealthRiskListSpecificRisksComments?: InputMaybe<
    Scalars['String']['input']
  >
  socialContactAdvice?: InputMaybe<SocialContactAdvice>
  socialContactAdviceComments?: InputMaybe<Scalars['String']['input']>
  socialContactAdviceTopics?: InputMaybe<Scalars['String']['input']>
  socialContactDifficulties?: InputMaybe<SocialContactDifficulties>
  socialContactDifficultiesList?: InputMaybe<
    Array<InputMaybe<SocialContactDifficultiesList>>
  >
  socialContactDifficultiesListOtherComments?: InputMaybe<
    Scalars['String']['input']
  >
  socialContactSupport?: InputMaybe<SocialContactSupport>
  sufficientActivitiesSupport?: InputMaybe<SufficientActivitiesSupport>
  sufficientMovingCare?: InputMaybe<SufficientMovingCare>
  sufficientProblemsSupport?: InputMaybe<SufficientProblemsSupport>
  therapies?: InputMaybe<Array<InputMaybe<Therapy>>>
  therapiesNeeded?: InputMaybe<TherapyNeeded>
  therapiesOtherComments?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  withRelativesIssues?: InputMaybe<WithRelativesIssues>
  withRelativesIssuesPersonInNeed?: InputMaybe<WithRelativesIssuesPersonInNeed>
}

/** All input for the `assessmentDetailReplicate` mutation. */
export type AssessmentDetailReplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<AssessmentDetailInput>>>
}

/** The output of our `assessmentDetailReplicate` mutation. */
export type AssessmentDetailReplicatePayload = {
  __typename?: 'AssessmentDetailReplicatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<Array<Maybe<AssessmentDetail>>>
}

export type AssessmentDetailSubscriptionPayload = {
  __typename?: 'AssessmentDetailSubscriptionPayload'
  assessmentDetail?: Maybe<AssessmentDetail>
  event?: Maybe<Scalars['String']['output']>
}

/** A `Assessment` edge in the connection. */
export type AssessmentEdge = {
  __typename?: 'AssessmentEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Assessment` at the end of the edge. */
  node?: Maybe<Assessment>
}

/** An input for mutations affecting `Assessment` */
export type AssessmentInput = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assignmentId?: InputMaybe<Scalars['UUID']['input']>
  careServiceType?: InputMaybe<CareServiceType>
  caregiverRegistered?: InputMaybe<Scalars['String']['input']>
  consultationAt?: InputMaybe<Scalars['Date']['input']>
  consultationBeginAt?: InputMaybe<Scalars['Time']['input']>
  consultationEndAt?: InputMaybe<Scalars['Time']['input']>
  consultationParticipants?: InputMaybe<
    Array<InputMaybe<ConsultationParticipant>>
  >
  consultationParticipantsOther?: InputMaybe<Scalars['String']['input']>
  consultationReason?: InputMaybe<AssessmentConsultationReason>
  consultationReasonOther?: InputMaybe<Scalars['String']['input']>
  contactDaughterInLawSonInLaw?: InputMaybe<ContactInput>
  contactDaughterSon?: InputMaybe<ContactInput>
  contactFriend?: InputMaybe<ContactInput>
  contactGeneralPractitioner?: InputMaybe<Array<InputMaybe<ContactInput>>>
  contactGrandchild?: InputMaybe<ContactInput>
  contactNeighbor?: InputMaybe<ContactInput>
  contactNursingService?: InputMaybe<ContactInput>
  contactOther?: InputMaybe<ContactInput>
  contactParent?: InputMaybe<ContactInput>
  contactPartner?: InputMaybe<ContactInput>
  contactSpecialistDoctor?: InputMaybe<Array<InputMaybe<ContactInput>>>
  contactSupervisor?: InputMaybe<ContactInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  lifeForm?: InputMaybe<Array<InputMaybe<LifeForm>>>
  lifeFormOther?: InputMaybe<Scalars['String']['input']>
  medicalTreatment?: InputMaybe<Array<InputMaybe<MedicalTreatment>>>
  orders?: InputMaybe<Array<InputMaybe<Orders>>>
  patientAddress?: InputMaybe<AddressInput>
  patientBirthdayAt?: InputMaybe<Scalars['Date']['input']>
  patientCareLevel?: InputMaybe<CareLevel>
  patientCareLevelNotes?: InputMaybe<Scalars['String']['input']>
  patientDiseases?: InputMaybe<Scalars['String']['input']>
  patientFinancialSituation?: InputMaybe<Scalars['String']['input']>
  patientGender?: InputMaybe<Gender>
  patientHasCareLevel?: InputMaybe<PatientHasCareLevel>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  patientInsuranceName?: InputMaybe<Scalars['String']['input']>
  patientInsuranceNumber?: InputMaybe<Scalars['String']['input']>
  patientInsuranceType?: InputMaybe<Scalars['String']['input']>
  patientName?: InputMaybe<Scalars['String']['input']>
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>
  patientSurname?: InputMaybe<Scalars['String']['input']>
  patientTitle?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relevantContacts?: InputMaybe<Array<InputMaybe<RelevantContacts>>>
  relevantContactsOther?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  state?: InputMaybe<AssessmentState>
  supportWithCare?: InputMaybe<Array<InputMaybe<SupportWithCare>>>
  supportWithCareOther?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type AssessmentMeasurement = Node & {
  __typename?: 'AssessmentMeasurement'
  /** Reads a single `AppUser` that is related to this `AssessmentMeasurement`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  /** Reads a single `Assessment` that is related to this `AssessmentMeasurement`. */
  assessment?: Maybe<Assessment>
  assessmentId?: Maybe<Scalars['UUID']['output']>
  careRelationship?: Maybe<MeasurementField>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  livingEnvironment?: Maybe<MeasurementField>
  mentalHealth?: Maybe<MeasurementField>
  mobility?: Maybe<MeasurementField>
  organization?: Maybe<MeasurementField>
  physicalHealth?: Maybe<MeasurementField>
  pushedAt: Scalars['Datetime']['output']
  relativeSituation?: Maybe<MeasurementField>
  rowId: Scalars['UUID']['output']
  selfSufficiency?: Maybe<MeasurementField>
  socialContacts?: Maybe<MeasurementField>
  updatedAt: Scalars['Datetime']['output']
}

/**
 * A condition to be used against `AssessmentMeasurement` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AssessmentMeasurementCondition = {
  /** Checks for equality with the object’s `appUserId` field. */
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `AssessmentMeasurement` values. */
export type AssessmentMeasurementConnection = {
  __typename?: 'AssessmentMeasurementConnection'
  /** A list of edges which contains the `AssessmentMeasurement` and cursor to aid in pagination. */
  edges: Array<Maybe<AssessmentMeasurementEdge>>
  /** A list of `AssessmentMeasurement` objects. */
  nodes: Array<Maybe<AssessmentMeasurement>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AssessmentMeasurement` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AssessmentMeasurement` edge in the connection. */
export type AssessmentMeasurementEdge = {
  __typename?: 'AssessmentMeasurementEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AssessmentMeasurement` at the end of the edge. */
  node?: Maybe<AssessmentMeasurement>
}

/** An input for mutations affecting `AssessmentMeasurement` */
export type AssessmentMeasurementInput = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  careRelationship?: InputMaybe<MeasurementFieldInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  livingEnvironment?: InputMaybe<MeasurementFieldInput>
  mentalHealth?: InputMaybe<MeasurementFieldInput>
  mobility?: InputMaybe<MeasurementFieldInput>
  organization?: InputMaybe<MeasurementFieldInput>
  physicalHealth?: InputMaybe<MeasurementFieldInput>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relativeSituation?: InputMaybe<MeasurementFieldInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selfSufficiency?: InputMaybe<MeasurementFieldInput>
  socialContacts?: InputMaybe<MeasurementFieldInput>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Methods to use when ordering `AssessmentMeasurement`. */
export enum AssessmentMeasurementOrderBy {
  AppUserIdAsc = 'APP_USER_ID_ASC',
  AppUserIdDesc = 'APP_USER_ID_DESC',
  AssessmentIdAsc = 'ASSESSMENT_ID_ASC',
  AssessmentIdDesc = 'ASSESSMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `AssessmentMeasurement`. Fields that are set will be updated. */
export type AssessmentMeasurementPatch = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  careRelationship?: InputMaybe<MeasurementFieldInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  livingEnvironment?: InputMaybe<MeasurementFieldInput>
  mentalHealth?: InputMaybe<MeasurementFieldInput>
  mobility?: InputMaybe<MeasurementFieldInput>
  organization?: InputMaybe<MeasurementFieldInput>
  physicalHealth?: InputMaybe<MeasurementFieldInput>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relativeSituation?: InputMaybe<MeasurementFieldInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selfSufficiency?: InputMaybe<MeasurementFieldInput>
  socialContacts?: InputMaybe<MeasurementFieldInput>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** All input for the `assessmentMeasurementReplicate` mutation. */
export type AssessmentMeasurementReplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<AssessmentMeasurementInput>>>
}

/** The output of our `assessmentMeasurementReplicate` mutation. */
export type AssessmentMeasurementReplicatePayload = {
  __typename?: 'AssessmentMeasurementReplicatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<Array<Maybe<AssessmentMeasurement>>>
}

export type AssessmentMeasurementSubscriptionPayload = {
  __typename?: 'AssessmentMeasurementSubscriptionPayload'
  assessmentMeasurement?: Maybe<AssessmentMeasurement>
  event?: Maybe<Scalars['String']['output']>
}

/** Methods to use when ordering `Assessment`. */
export enum AssessmentOrderBy {
  AppUserIdAsc = 'APP_USER_ID_ASC',
  AppUserIdDesc = 'APP_USER_ID_DESC',
  AssignmentIdAsc = 'ASSIGNMENT_ID_ASC',
  AssignmentIdDesc = 'ASSIGNMENT_ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `Assessment`. Fields that are set will be updated. */
export type AssessmentPatch = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assignmentId?: InputMaybe<Scalars['UUID']['input']>
  careServiceType?: InputMaybe<CareServiceType>
  caregiverRegistered?: InputMaybe<Scalars['String']['input']>
  consultationAt?: InputMaybe<Scalars['Date']['input']>
  consultationBeginAt?: InputMaybe<Scalars['Time']['input']>
  consultationEndAt?: InputMaybe<Scalars['Time']['input']>
  consultationParticipants?: InputMaybe<
    Array<InputMaybe<ConsultationParticipant>>
  >
  consultationParticipantsOther?: InputMaybe<Scalars['String']['input']>
  consultationReason?: InputMaybe<AssessmentConsultationReason>
  consultationReasonOther?: InputMaybe<Scalars['String']['input']>
  contactDaughterInLawSonInLaw?: InputMaybe<ContactInput>
  contactDaughterSon?: InputMaybe<ContactInput>
  contactFriend?: InputMaybe<ContactInput>
  contactGeneralPractitioner?: InputMaybe<Array<InputMaybe<ContactInput>>>
  contactGrandchild?: InputMaybe<ContactInput>
  contactNeighbor?: InputMaybe<ContactInput>
  contactNursingService?: InputMaybe<ContactInput>
  contactOther?: InputMaybe<ContactInput>
  contactParent?: InputMaybe<ContactInput>
  contactPartner?: InputMaybe<ContactInput>
  contactSpecialistDoctor?: InputMaybe<Array<InputMaybe<ContactInput>>>
  contactSupervisor?: InputMaybe<ContactInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  lifeForm?: InputMaybe<Array<InputMaybe<LifeForm>>>
  lifeFormOther?: InputMaybe<Scalars['String']['input']>
  medicalTreatment?: InputMaybe<Array<InputMaybe<MedicalTreatment>>>
  orders?: InputMaybe<Array<InputMaybe<Orders>>>
  patientAddress?: InputMaybe<AddressInput>
  patientBirthdayAt?: InputMaybe<Scalars['Date']['input']>
  patientCareLevel?: InputMaybe<CareLevel>
  patientCareLevelNotes?: InputMaybe<Scalars['String']['input']>
  patientDiseases?: InputMaybe<Scalars['String']['input']>
  patientFinancialSituation?: InputMaybe<Scalars['String']['input']>
  patientGender?: InputMaybe<Gender>
  patientHasCareLevel?: InputMaybe<PatientHasCareLevel>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  patientInsuranceName?: InputMaybe<Scalars['String']['input']>
  patientInsuranceNumber?: InputMaybe<Scalars['String']['input']>
  patientInsuranceType?: InputMaybe<Scalars['String']['input']>
  patientName?: InputMaybe<Scalars['String']['input']>
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>
  patientSurname?: InputMaybe<Scalars['String']['input']>
  patientTitle?: InputMaybe<Scalars['String']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  relevantContacts?: InputMaybe<Array<InputMaybe<RelevantContacts>>>
  relevantContactsOther?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  state?: InputMaybe<AssessmentState>
  supportWithCare?: InputMaybe<Array<InputMaybe<SupportWithCare>>>
  supportWithCareOther?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** All input for the `assessmentReplicate` mutation. */
export type AssessmentReplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<AssessmentInput>>>
}

/** The output of our `assessmentReplicate` mutation. */
export type AssessmentReplicatePayload = {
  __typename?: 'AssessmentReplicatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<Array<Maybe<Assessment>>>
}

export type AssessmentSignature = Node & {
  __typename?: 'AssessmentSignature'
  /** Reads a single `AppUser` that is related to this `AssessmentSignature`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  /** Reads a single `Assessment` that is related to this `AssessmentSignature`. */
  assessment?: Maybe<Assessment>
  assessmentId?: Maybe<Scalars['UUID']['output']>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  pushedAt: Scalars['Datetime']['output']
  rowId: Scalars['UUID']['output']
  signatureConfirmPartnerMediation?: Maybe<Scalars['String']['output']>
  signatureConfirmProtocol?: Maybe<Scalars['String']['output']>
  signatureSection37CareRecipient?: Maybe<Scalars['String']['output']>
  signatureSection37Caregiver?: Maybe<Scalars['String']['output']>
  signatureSection37Counselor?: Maybe<Scalars['String']['output']>
  signatureSection45BillingPerson?: Maybe<Scalars['String']['output']>
  signatureSection45Caregiver?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
}

/**
 * A condition to be used against `AssessmentSignature` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AssessmentSignatureCondition = {
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `AssessmentSignature` values. */
export type AssessmentSignatureConnection = {
  __typename?: 'AssessmentSignatureConnection'
  /** A list of edges which contains the `AssessmentSignature` and cursor to aid in pagination. */
  edges: Array<Maybe<AssessmentSignatureEdge>>
  /** A list of `AssessmentSignature` objects. */
  nodes: Array<Maybe<AssessmentSignature>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AssessmentSignature` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AssessmentSignature` edge in the connection. */
export type AssessmentSignatureEdge = {
  __typename?: 'AssessmentSignatureEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AssessmentSignature` at the end of the edge. */
  node?: Maybe<AssessmentSignature>
}

/** An input for mutations affecting `AssessmentSignature` */
export type AssessmentSignatureInput = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  signatureConfirmPartnerMediation?: InputMaybe<Scalars['String']['input']>
  signatureConfirmProtocol?: InputMaybe<Scalars['String']['input']>
  signatureSection37CareRecipient?: InputMaybe<Scalars['String']['input']>
  signatureSection37Caregiver?: InputMaybe<Scalars['String']['input']>
  signatureSection37Counselor?: InputMaybe<Scalars['String']['input']>
  signatureSection45BillingPerson?: InputMaybe<Scalars['String']['input']>
  signatureSection45Caregiver?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Methods to use when ordering `AssessmentSignature`. */
export enum AssessmentSignatureOrderBy {
  AssessmentIdAsc = 'ASSESSMENT_ID_ASC',
  AssessmentIdDesc = 'ASSESSMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `AssessmentSignature`. Fields that are set will be updated. */
export type AssessmentSignaturePatch = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  assessmentId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  pushedAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  signatureConfirmPartnerMediation?: InputMaybe<Scalars['String']['input']>
  signatureConfirmProtocol?: InputMaybe<Scalars['String']['input']>
  signatureSection37CareRecipient?: InputMaybe<Scalars['String']['input']>
  signatureSection37Caregiver?: InputMaybe<Scalars['String']['input']>
  signatureSection37Counselor?: InputMaybe<Scalars['String']['input']>
  signatureSection45BillingPerson?: InputMaybe<Scalars['String']['input']>
  signatureSection45Caregiver?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** All input for the `assessmentSignatureReplicate` mutation. */
export type AssessmentSignatureReplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<AssessmentSignatureInput>>>
}

/** The output of our `assessmentSignatureReplicate` mutation. */
export type AssessmentSignatureReplicatePayload = {
  __typename?: 'AssessmentSignatureReplicatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<Array<Maybe<AssessmentSignature>>>
}

export type AssessmentSignatureSubscriptionPayload = {
  __typename?: 'AssessmentSignatureSubscriptionPayload'
  assessmentSignature?: Maybe<AssessmentSignature>
  event?: Maybe<Scalars['String']['output']>
}

export enum AssessmentState {
  Done = 'DONE',
  DoneUnsuccessful = 'DONE_UNSUCCESSFUL',
  Open = 'OPEN',
  Progress = 'PROGRESS',
}

export type AssessmentSubscriptionPayload = {
  __typename?: 'AssessmentSubscriptionPayload'
  assessment?: Maybe<Assessment>
  event?: Maybe<Scalars['String']['output']>
}

export enum AssessmentSupportIsEnsured {
  No = 'NO',
  Yes = 'YES',
}

export type Assignment = Node & {
  __typename?: 'Assignment'
  /** Reads a single `AppUser` that is related to this `Assignment`. */
  appUser?: Maybe<AppUser>
  appUserId: Scalars['UUID']['output']
  appointmentAt: Scalars['Datetime']['output']
  /** Reads a single `Assessment` that is related to this `Assignment`. */
  assessment?: Maybe<Assessment>
  createdAt: Scalars['Datetime']['output']
  deleted: Scalars['Boolean']['output']
  /** External ID provided by client API */
  externalId: Scalars['String']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
}

/**
 * A condition to be used against `Assignment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AssignmentCondition = {
  /** Checks for equality with the object’s `appUserId` field. */
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `Assignment` values. */
export type AssignmentConnection = {
  __typename?: 'AssignmentConnection'
  /** A list of edges which contains the `Assignment` and cursor to aid in pagination. */
  edges: Array<Maybe<AssignmentEdge>>
  /** A list of `Assignment` objects. */
  nodes: Array<Maybe<Assignment>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Assignment` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Assignment` edge in the connection. */
export type AssignmentEdge = {
  __typename?: 'AssignmentEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Assignment` at the end of the edge. */
  node?: Maybe<Assignment>
}

/** An input for mutations affecting `Assignment` */
export type AssignmentInput = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  appointmentAt: Scalars['Datetime']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  /** External ID provided by client API */
  externalId: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Methods to use when ordering `Assignment`. */
export enum AssignmentOrderBy {
  AppUserIdAsc = 'APP_USER_ID_ASC',
  AppUserIdDesc = 'APP_USER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
}

/** Represents an update to a `Assignment`. Fields that are set will be updated. */
export type AssignmentPatch = {
  appUserId?: InputMaybe<Scalars['UUID']['input']>
  appointmentAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  /** External ID provided by client API */
  externalId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type AssignmentSubscriptionPayload = {
  __typename?: 'AssignmentSubscriptionPayload'
  assignment?: Maybe<Assignment>
  event?: Maybe<Scalars['String']['output']>
}

export enum Assistance {
  CareBed = 'CARE_BED',
  DevicesToFoodIntake = 'DEVICES_TO_FOOD_INTAKE',
  DevicesToSupportExcretion = 'DEVICES_TO_SUPPORT_EXCRETION',
  HomeEmergencyCallSystem = 'HOME_EMERGENCY_CALL_SYSTEM',
  Mobility = 'MOBILITY',
  Other = 'OTHER',
  PersonalHygiene = 'PERSONAL_HYGIENE',
  PhysicalAid = 'PHYSICAL_AID',
  PositioningInBed = 'POSITIONING_IN_BED',
}

export enum AssistanceNeeded {
  No = 'NO',
  Yes = 'YES',
}

export enum AssistanceService {
  AuthorizedIndividualCaregiver = 'AUTHORIZED_INDIVIDUAL_CAREGIVER',
  DayCare = 'DAY_CARE',
  NightCare = 'NIGHT_CARE',
  Other = 'OTHER',
  OutpatientCare = 'OUTPATIENT_CARE',
  PreventiveCare = 'PREVENTIVE_CARE',
  ShortTermCare = 'SHORT_TERM_CARE',
}

export enum AssistanceServiceNeeded {
  No = 'NO',
  Yes = 'YES',
}

export enum BehaviorChanges {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum BehaviorChangesList {
  Aggressiveness = 'AGGRESSIVENESS',
  Apathy = 'APATHY',
  MotorRestlessness = 'MOTOR_RESTLESSNESS',
  NocturnalRestlessness = 'NOCTURNAL_RESTLESSNESS',
  Other = 'OTHER',
  Resistance = 'RESISTANCE',
  VocalAbnormalities = 'VOCAL_ABNORMALITIES',
}

export enum CareCounselingIndicatedSection7A {
  No = 'NO',
  Yes = 'YES',
}

export enum CareCounselingRequestedSection7A {
  No = 'NO',
  Yes = 'YES',
}

export enum CareIssues {
  No = 'NO',
  Yes = 'YES',
}

export enum CareLevel {
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5',
}

export enum CareRelationshipAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum CareServiceType {
  CareAllowance = 'CARE_ALLOWANCE',
  CareBenefitsInKind = 'CARE_BENEFITS_IN_KIND',
  CareCashBenefit = 'CARE_CASH_BENEFIT',
}

export enum CareSituation {
  Bad = 'BAD',
  Good = 'GOOD',
  Partially = 'PARTIALLY',
}

export enum CareWellOrganized {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum ChangesSupportNeeded {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoDifficulties = 'NO_DIFFICULTIES',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum ConsentToProcessingByInsuranceSection45 {
  No = 'NO',
  Yes = 'YES',
}

export enum ConsentToProcessingCounselingResultsSection7A {
  No = 'NO',
  Yes = 'YES',
}

export enum ConsentToShareCareSupportInformation {
  No = 'NO',
  Yes = 'YES',
}

export enum ConsentToShareImprovementRecommendations {
  No = 'NO',
  Yes = 'YES',
}

export enum ConsentToSiteInspectionAndToShareInformation {
  No = 'NO',
  Yes = 'YES',
}

export enum ConsultationParticipant {
  DaughterInLawSonInLaw = 'DAUGHTER_IN_LAW_SON_IN_LAW',
  DaughterSon = 'DAUGHTER_SON',
  Friend = 'FRIEND',
  Grandchild = 'GRANDCHILD',
  Neighbor = 'NEIGHBOR',
  Other = 'OTHER',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  PersonInNeedOfCare = 'PERSON_IN_NEED_OF_CARE',
  Supervisor = 'SUPERVISOR',
}

export type Contact = {
  __typename?: 'Contact'
  address?: Maybe<Scalars['String']['output']>
  healthInsuranceFund?: Maybe<Scalars['String']['output']>
  healthInsuranceNumber?: Maybe<Scalars['String']['output']>
  healthInsuranceType?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
}

/** An input for mutations affecting `Contact` */
export type ContactInput = {
  address?: InputMaybe<Scalars['String']['input']>
  healthInsuranceFund?: InputMaybe<Scalars['String']['input']>
  healthInsuranceNumber?: InputMaybe<Scalars['String']['input']>
  healthInsuranceType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

export enum CounselingViaVideoConference {
  No = 'NO',
  Yes = 'YES',
}

/** All input for the create `AssessmentAdditionalInfo` mutation. */
export type CreateAssessmentAdditionalInfoInput = {
  /** The `AssessmentAdditionalInfo` to be created by this mutation. */
  assessmentAdditionalInfo: AssessmentAdditionalInfoInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `AssessmentAdditionalInfo` mutation. */
export type CreateAssessmentAdditionalInfoPayload = {
  __typename?: 'CreateAssessmentAdditionalInfoPayload'
  /** The `AssessmentAdditionalInfo` that was created by this mutation. */
  assessmentAdditionalInfo?: Maybe<AssessmentAdditionalInfo>
  /** An edge for our `AssessmentAdditionalInfo`. May be used by Relay 1. */
  assessmentAdditionalInfoEdge?: Maybe<AssessmentAdditionalInfoEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AssessmentAdditionalInfo` mutation. */
export type CreateAssessmentAdditionalInfoPayloadAssessmentAdditionalInfoEdgeArgs =
  {
    orderBy?: Array<AssessmentAdditionalInfoOrderBy>
  }

/** All input for the create `AssessmentDetail` mutation. */
export type CreateAssessmentDetailInput = {
  /** The `AssessmentDetail` to be created by this mutation. */
  assessmentDetail: AssessmentDetailInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `AssessmentDetail` mutation. */
export type CreateAssessmentDetailPayload = {
  __typename?: 'CreateAssessmentDetailPayload'
  /** The `AssessmentDetail` that was created by this mutation. */
  assessmentDetail?: Maybe<AssessmentDetail>
  /** An edge for our `AssessmentDetail`. May be used by Relay 1. */
  assessmentDetailEdge?: Maybe<AssessmentDetailEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AssessmentDetail` mutation. */
export type CreateAssessmentDetailPayloadAssessmentDetailEdgeArgs = {
  orderBy?: Array<AssessmentDetailOrderBy>
}

/** All input for the create `Assessment` mutation. */
export type CreateAssessmentInput = {
  /** The `Assessment` to be created by this mutation. */
  assessment: AssessmentInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** All input for the create `AssessmentMeasurement` mutation. */
export type CreateAssessmentMeasurementInput = {
  /** The `AssessmentMeasurement` to be created by this mutation. */
  assessmentMeasurement: AssessmentMeasurementInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `AssessmentMeasurement` mutation. */
export type CreateAssessmentMeasurementPayload = {
  __typename?: 'CreateAssessmentMeasurementPayload'
  /** The `AssessmentMeasurement` that was created by this mutation. */
  assessmentMeasurement?: Maybe<AssessmentMeasurement>
  /** An edge for our `AssessmentMeasurement`. May be used by Relay 1. */
  assessmentMeasurementEdge?: Maybe<AssessmentMeasurementEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AssessmentMeasurement` mutation. */
export type CreateAssessmentMeasurementPayloadAssessmentMeasurementEdgeArgs = {
  orderBy?: Array<AssessmentMeasurementOrderBy>
}

/** The output of our create `Assessment` mutation. */
export type CreateAssessmentPayload = {
  __typename?: 'CreateAssessmentPayload'
  /** The `Assessment` that was created by this mutation. */
  assessment?: Maybe<Assessment>
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Assessment` mutation. */
export type CreateAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: Array<AssessmentOrderBy>
}

/** All input for the create `AssessmentSignature` mutation. */
export type CreateAssessmentSignatureInput = {
  /** The `AssessmentSignature` to be created by this mutation. */
  assessmentSignature: AssessmentSignatureInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `AssessmentSignature` mutation. */
export type CreateAssessmentSignaturePayload = {
  __typename?: 'CreateAssessmentSignaturePayload'
  /** The `AssessmentSignature` that was created by this mutation. */
  assessmentSignature?: Maybe<AssessmentSignature>
  /** An edge for our `AssessmentSignature`. May be used by Relay 1. */
  assessmentSignatureEdge?: Maybe<AssessmentSignatureEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AssessmentSignature` mutation. */
export type CreateAssessmentSignaturePayloadAssessmentSignatureEdgeArgs = {
  orderBy?: Array<AssessmentSignatureOrderBy>
}

/** All input for the create `Assignment` mutation. */
export type CreateAssignmentInput = {
  /** The `Assignment` to be created by this mutation. */
  assignment: AssignmentInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `Assignment` mutation. */
export type CreateAssignmentPayload = {
  __typename?: 'CreateAssignmentPayload'
  /** The `Assignment` that was created by this mutation. */
  assignment?: Maybe<Assignment>
  /** An edge for our `Assignment`. May be used by Relay 1. */
  assignmentEdge?: Maybe<AssignmentEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Assignment` mutation. */
export type CreateAssignmentPayloadAssignmentEdgeArgs = {
  orderBy?: Array<AssignmentOrderBy>
}

/** All input for the `deleteAppUserById` mutation. */
export type DeleteAppUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `AppUser` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteAppUser` mutation. */
export type DeleteAppUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `AppUser` mutation. */
export type DeleteAppUserPayload = {
  __typename?: 'DeleteAppUserPayload'
  /** The `AppUser` that was deleted by this mutation. */
  appUser?: Maybe<AppUser>
  /** An edge for our `AppUser`. May be used by Relay 1. */
  appUserEdge?: Maybe<AppUserEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedAppUserId?: Maybe<Scalars['ID']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `AppUser` mutation. */
export type DeleteAppUserPayloadAppUserEdgeArgs = {
  orderBy?: Array<AppUserOrderBy>
}

export enum DepressedRecently {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum DiseaseMeasures {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum DiseaseMeasuresList {
  BodyConditionMonitoring = 'BODY_CONDITION_MONITORING',
  DietDueToIllness = 'DIET_DUE_TO_ILLNESS',
  DoctorVisits = 'DOCTOR_VISITS',
  DressingWoundsCare = 'DRESSING_WOUNDS_CARE',
  HandlingBodyHuggingAids = 'HANDLING_BODY_HUGGING_AIDS',
  Medication = 'MEDICATION',
  Other = 'OTHER',
  Therapy = 'THERAPY',
}

/** An input for mutations affecting `DocumentCheckpoint` */
export type DocumentCheckpointInput = {
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export enum FallenCareRecently {
  Nearly = 'NEARLY',
  No = 'NO',
  Yes = 'YES',
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
}

export enum GenerallyPhysicalActive {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

/** All input for the `getOrCreateAppUser` mutation. */
export type GetOrCreateAppUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  emailAddress: Scalars['String']['input']
  name: Scalars['String']['input']
  userId: Scalars['UUID']['input']
}

/** The output of our `getOrCreateAppUser` mutation. */
export type GetOrCreateAppUserPayload = {
  __typename?: 'GetOrCreateAppUserPayload'
  /** An edge for our `AppUser`. May be used by Relay 1. */
  appUserEdge?: Maybe<AppUserEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  result?: Maybe<AppUser>
}

/** The output of our `getOrCreateAppUser` mutation. */
export type GetOrCreateAppUserPayloadAppUserEdgeArgs = {
  orderBy?: Array<AppUserOrderBy>
}

export enum HospitalizedRecently {
  EmergencyOnceAtLeast = 'EMERGENCY_ONCE_AT_LEAST',
  NotKnown = 'NOT_KNOWN',
  NoPlannedOne = 'NO_PLANNED_ONE',
  PlannedMoreThanOnce = 'PLANNED_MORE_THAN_ONCE',
}

export enum LessEnjoyment {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum LifeForm {
  LivingAlone = 'LIVING_ALONE',
  LivingWithDaughterInLawSonInLaw = 'LIVING_WITH_DAUGHTER_IN_LAW_SON_IN_LAW',
  LivingWithOther = 'LIVING_WITH_OTHER',
  LivingWithParents = 'LIVING_WITH_PARENTS',
  LivingWithPartner = 'LIVING_WITH_PARTNER',
}

export enum LivingEnvironmentAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum LivingEnvironmentProblems {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum LivingEnvironmentProblemsList {
  ApartmentAccess = 'APARTMENT_ACCESS',
  HouseLocation = 'HOUSE_LOCATION',
  LivingIssues = 'LIVING_ISSUES',
  MobilityRestrictions = 'MOBILITY_RESTRICTIONS',
  Other = 'OTHER',
  SanitaryAccess = 'SANITARY_ACCESS',
  UnsafeArea = 'UNSAFE_AREA',
}

export enum LivingEnvironmentSupport {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoDifficulties = 'NO_DIFFICULTIES',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export type MeasureResponsible = {
  __typename?: 'MeasureResponsible'
  bodyConditionMonitoring?: Maybe<Array<Maybe<Responsible>>>
  bodyConditionMonitoringOtherComments?: Maybe<Scalars['String']['output']>
  dietDueToIllness?: Maybe<Array<Maybe<Responsible>>>
  dietDueToIllnessOtherComments?: Maybe<Scalars['String']['output']>
  doctorVisits?: Maybe<Array<Maybe<Responsible>>>
  doctorVisitsOtherComments?: Maybe<Scalars['String']['output']>
  dressingWoundsCare?: Maybe<Array<Maybe<Responsible>>>
  dressingWoundsCareOtherComments?: Maybe<Scalars['String']['output']>
  handlingBodyHuggingAids?: Maybe<Array<Maybe<Responsible>>>
  handlingBodyHuggingAidsOtherComments?: Maybe<Scalars['String']['output']>
  medication?: Maybe<Array<Maybe<Responsible>>>
  medicationOtherComments?: Maybe<Scalars['String']['output']>
  other?: Maybe<Array<Maybe<Responsible>>>
  otherOtherComments?: Maybe<Scalars['String']['output']>
  therapy?: Maybe<Array<Maybe<Responsible>>>
  therapyOtherComments?: Maybe<Scalars['String']['output']>
}

/** An input for mutations affecting `MeasureResponsible` */
export type MeasureResponsibleInput = {
  bodyConditionMonitoring?: InputMaybe<Array<InputMaybe<Responsible>>>
  bodyConditionMonitoringOtherComments?: InputMaybe<Scalars['String']['input']>
  dietDueToIllness?: InputMaybe<Array<InputMaybe<Responsible>>>
  dietDueToIllnessOtherComments?: InputMaybe<Scalars['String']['input']>
  doctorVisits?: InputMaybe<Array<InputMaybe<Responsible>>>
  doctorVisitsOtherComments?: InputMaybe<Scalars['String']['input']>
  dressingWoundsCare?: InputMaybe<Array<InputMaybe<Responsible>>>
  dressingWoundsCareOtherComments?: InputMaybe<Scalars['String']['input']>
  handlingBodyHuggingAids?: InputMaybe<Array<InputMaybe<Responsible>>>
  handlingBodyHuggingAidsOtherComments?: InputMaybe<Scalars['String']['input']>
  medication?: InputMaybe<Array<InputMaybe<Responsible>>>
  medicationOtherComments?: InputMaybe<Scalars['String']['input']>
  other?: InputMaybe<Array<InputMaybe<Responsible>>>
  otherOtherComments?: InputMaybe<Scalars['String']['input']>
  therapy?: InputMaybe<Array<InputMaybe<Responsible>>>
  therapyOtherComments?: InputMaybe<Scalars['String']['input']>
}

export type MeasurementField = {
  __typename?: 'MeasurementField'
  arrayValues?: Maybe<Array<Maybe<ArrayField>>>
  stringValues?: Maybe<Array<Maybe<StringField>>>
}

/** An input for mutations affecting `MeasurementField` */
export type MeasurementFieldInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<ArrayFieldInput>>>
  stringValues?: InputMaybe<Array<InputMaybe<StringFieldInput>>>
}

export enum MedicalTreatment {
  GeneralPractitioner = 'GENERAL_PRACTITIONER',
  No = 'NO',
  SpecialistDoctor = 'SPECIALIST_DOCTOR',
}

export enum MentalDifficulties {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum MentalDifficultiesList {
  Communicating = 'COMMUNICATING',
  DecisionMaking = 'DECISION_MAKING',
  Memory = 'MEMORY',
  OrientationInTime = 'ORIENTATION_IN_TIME',
  Other = 'OTHER',
  PerformingDailyTasks = 'PERFORMING_DAILY_TASKS',
  RecognizingPeople = 'RECOGNIZING_PEOPLE',
  RecognizingRisks = 'RECOGNIZING_RISKS',
  TakingPartInConversations = 'TAKING_PART_IN_CONVERSATIONS',
  UnderstandingInformation = 'UNDERSTANDING_INFORMATION',
  UnderstandingRequests = 'UNDERSTANDING_REQUESTS',
}

export enum MentalHealthCounseling {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum MobilityAreaAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum MovingDifficulties {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum MovingDifficultiesActivity {
  ClimbingStairs = 'CLIMBING_STAIRS',
  MovingAroundHome = 'MOVING_AROUND_HOME',
  MovingAroundOutside = 'MOVING_AROUND_OUTSIDE',
  MovingInBed = 'MOVING_IN_BED',
  Other = 'OTHER',
  SittingUpright = 'SITTING_UPRIGHT',
  StandingUp = 'STANDING_UP',
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation'
  /** Replicates a list of `AssessmentAdditionalInfo` documents. Used for data replication from the frontend. */
  assessmentAdditionalInfoReplicate?: Maybe<AssessmentAdditionalInfoReplicatePayload>
  /** Replicates a list of `AssessmentDetail` documents. Used for data replication from the frontend. */
  assessmentDetailReplicate?: Maybe<AssessmentDetailReplicatePayload>
  /** Replicates a list of `AssessmentMeasurement` documents. Used for data replication from the frontend. */
  assessmentMeasurementReplicate?: Maybe<AssessmentMeasurementReplicatePayload>
  /** Replicates a list of `Assessment` documents. Used for data replication from the frontend. */
  assessmentReplicate?: Maybe<AssessmentReplicatePayload>
  /** Replicates a list of `AssessmentSignature` documents. Used for data replication from the frontend. */
  assessmentSignatureReplicate?: Maybe<AssessmentSignatureReplicatePayload>
  /** Creates a single `Assessment`. */
  createAssessment?: Maybe<CreateAssessmentPayload>
  /** Creates a single `AssessmentAdditionalInfo`. */
  createAssessmentAdditionalInfo?: Maybe<CreateAssessmentAdditionalInfoPayload>
  /** Creates a single `AssessmentDetail`. */
  createAssessmentDetail?: Maybe<CreateAssessmentDetailPayload>
  /** Creates a single `AssessmentMeasurement`. */
  createAssessmentMeasurement?: Maybe<CreateAssessmentMeasurementPayload>
  /** Creates a single `AssessmentSignature`. */
  createAssessmentSignature?: Maybe<CreateAssessmentSignaturePayload>
  /** Creates a single `Assignment`. */
  createAssignment?: Maybe<CreateAssignmentPayload>
  /** Deletes a single `AppUser` using a unique key. */
  deleteAppUser?: Maybe<DeleteAppUserPayload>
  /** Deletes a single `AppUser` using its globally unique id. */
  deleteAppUserById?: Maybe<DeleteAppUserPayload>
  /** Fetches or creates a new `AppUser`, based on the current `authentication` state. */
  getOrCreateAppUser?: Maybe<GetOrCreateAppUserPayload>
  /** Updates a single `Assessment` using a unique key and a patch. */
  updateAssessment?: Maybe<UpdateAssessmentPayload>
  /** Updates a single `AssessmentAdditionalInfo` using a unique key and a patch. */
  updateAssessmentAdditionalInfo?: Maybe<UpdateAssessmentAdditionalInfoPayload>
  /** Updates a single `AssessmentAdditionalInfo` using a unique key and a patch. */
  updateAssessmentAdditionalInfoByAssessmentId?: Maybe<UpdateAssessmentAdditionalInfoPayload>
  /** Updates a single `AssessmentAdditionalInfo` using its globally unique id and a patch. */
  updateAssessmentAdditionalInfoById?: Maybe<UpdateAssessmentAdditionalInfoPayload>
  /** Updates a single `Assessment` using a unique key and a patch. */
  updateAssessmentByAssignmentId?: Maybe<UpdateAssessmentPayload>
  /** Updates a single `Assessment` using its globally unique id and a patch. */
  updateAssessmentById?: Maybe<UpdateAssessmentPayload>
  /** Updates a single `AssessmentDetail` using a unique key and a patch. */
  updateAssessmentDetail?: Maybe<UpdateAssessmentDetailPayload>
  /** Updates a single `AssessmentDetail` using a unique key and a patch. */
  updateAssessmentDetailByAssessmentId?: Maybe<UpdateAssessmentDetailPayload>
  /** Updates a single `AssessmentDetail` using its globally unique id and a patch. */
  updateAssessmentDetailById?: Maybe<UpdateAssessmentDetailPayload>
  /** Updates a single `AssessmentMeasurement` using a unique key and a patch. */
  updateAssessmentMeasurement?: Maybe<UpdateAssessmentMeasurementPayload>
  /** Updates a single `AssessmentMeasurement` using a unique key and a patch. */
  updateAssessmentMeasurementByAssessmentId?: Maybe<UpdateAssessmentMeasurementPayload>
  /** Updates a single `AssessmentMeasurement` using its globally unique id and a patch. */
  updateAssessmentMeasurementById?: Maybe<UpdateAssessmentMeasurementPayload>
  /** Updates a single `AssessmentSignature` using a unique key and a patch. */
  updateAssessmentSignature?: Maybe<UpdateAssessmentSignaturePayload>
  /** Updates a single `AssessmentSignature` using a unique key and a patch. */
  updateAssessmentSignatureByAssessmentId?: Maybe<UpdateAssessmentSignaturePayload>
  /** Updates a single `AssessmentSignature` using its globally unique id and a patch. */
  updateAssessmentSignatureById?: Maybe<UpdateAssessmentSignaturePayload>
  /** Updates a single `Assignment` using a unique key and a patch. */
  updateAssignment?: Maybe<UpdateAssignmentPayload>
  /** Updates a single `Assignment` using its globally unique id and a patch. */
  updateAssignmentById?: Maybe<UpdateAssignmentPayload>
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssessmentAdditionalInfoReplicateArgs = {
  input: AssessmentAdditionalInfoReplicateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssessmentDetailReplicateArgs = {
  input: AssessmentDetailReplicateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssessmentMeasurementReplicateArgs = {
  input: AssessmentMeasurementReplicateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssessmentReplicateArgs = {
  input: AssessmentReplicateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssessmentSignatureReplicateArgs = {
  input: AssessmentSignatureReplicateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentArgs = {
  input: CreateAssessmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentAdditionalInfoArgs = {
  input: CreateAssessmentAdditionalInfoInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentDetailArgs = {
  input: CreateAssessmentDetailInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentMeasurementArgs = {
  input: CreateAssessmentMeasurementInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentSignatureArgs = {
  input: CreateAssessmentSignatureInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssignmentArgs = {
  input: CreateAssignmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppUserArgs = {
  input: DeleteAppUserInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppUserByIdArgs = {
  input: DeleteAppUserByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetOrCreateAppUserArgs = {
  input: GetOrCreateAppUserInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentArgs = {
  input: UpdateAssessmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentAdditionalInfoArgs = {
  input: UpdateAssessmentAdditionalInfoInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentAdditionalInfoByAssessmentIdArgs = {
  input: UpdateAssessmentAdditionalInfoByAssessmentIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentAdditionalInfoByIdArgs = {
  input: UpdateAssessmentAdditionalInfoByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentByAssignmentIdArgs = {
  input: UpdateAssessmentByAssignmentIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentByIdArgs = {
  input: UpdateAssessmentByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentDetailArgs = {
  input: UpdateAssessmentDetailInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentDetailByAssessmentIdArgs = {
  input: UpdateAssessmentDetailByAssessmentIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentDetailByIdArgs = {
  input: UpdateAssessmentDetailByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentMeasurementArgs = {
  input: UpdateAssessmentMeasurementInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentMeasurementByAssessmentIdArgs = {
  input: UpdateAssessmentMeasurementByAssessmentIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentMeasurementByIdArgs = {
  input: UpdateAssessmentMeasurementByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentSignatureArgs = {
  input: UpdateAssessmentSignatureInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentSignatureByAssessmentIdArgs = {
  input: UpdateAssessmentSignatureByAssessmentIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentSignatureByIdArgs = {
  input: UpdateAssessmentSignatureByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssignmentArgs = {
  input: UpdateAssignmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssignmentByIdArgs = {
  input: UpdateAssignmentByIdInput
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
}

export enum Orders {
  CareDirectiveAvailable = 'CARE_DIRECTIVE_AVAILABLE',
  NoOrders = 'NO_ORDERS',
  PatientDirectiveAvailable = 'PATIENT_DIRECTIVE_AVAILABLE',
  PowerOfAttorneyAvailable = 'POWER_OF_ATTORNEY_AVAILABLE',
}

export enum OrganizationCareAdviceNeeded {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum OtherAssistanceNeeded {
  No = 'NO',
  Yes = 'YES',
}

export enum OtherAssistanceService {
  HomeHelp = 'HOME_HELP',
  MealService = 'MEAL_SERVICE',
  NeighborhoodHelp = 'NEIGHBORHOOD_HELP',
  Other = 'OTHER',
  PrivateCaregiver = 'PRIVATE_CAREGIVER',
  SeverelyDisabledPerson = 'SEVERELY_DISABLED_PERSON',
  VoluntaryVisiting = 'VOLUNTARY_VISITING',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>
}

export enum PatientHasCareLevel {
  No = 'NO',
  Yes = 'YES',
}

export enum PhysicalHealthAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum PhysicalProblems {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum PhysicalProblemsList {
  ChronicPain = 'CHRONIC_PAIN',
  CirculatoryFluctuations = 'CIRCULATORY_FLUCTUATIONS',
  Dizziness = 'DIZZINESS',
  FluidBalance = 'FLUID_BALANCE',
  HearingLoss = 'HEARING_LOSS',
  Incontinence = 'INCONTINENCE',
  Other = 'OTHER',
  OverweightUnderweight = 'OVERWEIGHT_UNDERWEIGHT',
  ProblemsChewingSwallowing = 'PROBLEMS_CHEWING_SWALLOWING',
  ShortnessOfBreath = 'SHORTNESS_OF_BREATH',
  SkinProblems = 'SKIN_PROBLEMS',
  VisualDisturbances = 'VISUAL_DISTURBANCES',
  Wounds = 'WOUNDS',
}

export enum ProtocolDispatch {
  Email = 'EMAIL',
  OnSite = 'ON_SITE',
  StandardMail = 'STANDARD_MAIL',
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query'
  /** Get a single `AppUser`. */
  appUser?: Maybe<AppUser>
  /** Reads a single `AppUser` using its globally unique `ID`. */
  appUserById?: Maybe<AppUser>
  /** Fetches a list of `AppUser` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  appUserDocuments?: Maybe<AppUserConnection>
  /** Reads and enables pagination through a set of `AppUser`. */
  appUsers?: Maybe<AppUserConnection>
  /** Get a single `Assessment`. */
  assessment?: Maybe<Assessment>
  /** Get a single `AssessmentAdditionalInfo`. */
  assessmentAdditionalInfo?: Maybe<AssessmentAdditionalInfo>
  /** Get a single `AssessmentAdditionalInfo`. */
  assessmentAdditionalInfoByAssessmentId?: Maybe<AssessmentAdditionalInfo>
  /** Reads a single `AssessmentAdditionalInfo` using its globally unique `ID`. */
  assessmentAdditionalInfoById?: Maybe<AssessmentAdditionalInfo>
  /** Fetches a list of `AssessmentAdditionalInfo` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assessmentAdditionalInfoDocuments?: Maybe<AssessmentAdditionalInfoConnection>
  /** Reads and enables pagination through a set of `AssessmentAdditionalInfo`. */
  assessmentAdditionalInfos?: Maybe<AssessmentAdditionalInfoConnection>
  /** Get a single `Assessment`. */
  assessmentByAssignmentId?: Maybe<Assessment>
  /** Reads a single `Assessment` using its globally unique `ID`. */
  assessmentById?: Maybe<Assessment>
  /** Get a single `AssessmentDetail`. */
  assessmentDetail?: Maybe<AssessmentDetail>
  /** Get a single `AssessmentDetail`. */
  assessmentDetailByAssessmentId?: Maybe<AssessmentDetail>
  /** Reads a single `AssessmentDetail` using its globally unique `ID`. */
  assessmentDetailById?: Maybe<AssessmentDetail>
  /** Fetches a list of `AssessmentDetail` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assessmentDetailDocuments?: Maybe<AssessmentDetailConnection>
  /** Reads and enables pagination through a set of `AssessmentDetail`. */
  assessmentDetails?: Maybe<AssessmentDetailConnection>
  /** Fetches a list of `Assessment` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assessmentDocuments?: Maybe<AssessmentConnection>
  /** Get a single `AssessmentMeasurement`. */
  assessmentMeasurement?: Maybe<AssessmentMeasurement>
  /** Get a single `AssessmentMeasurement`. */
  assessmentMeasurementByAssessmentId?: Maybe<AssessmentMeasurement>
  /** Reads a single `AssessmentMeasurement` using its globally unique `ID`. */
  assessmentMeasurementById?: Maybe<AssessmentMeasurement>
  /** Fetches a list of `AssessmentMeasurement` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assessmentMeasurementDocuments?: Maybe<AssessmentMeasurementConnection>
  /** Reads and enables pagination through a set of `AssessmentMeasurement`. */
  assessmentMeasurements?: Maybe<AssessmentMeasurementConnection>
  /** Get a single `AssessmentSignature`. */
  assessmentSignature?: Maybe<AssessmentSignature>
  /** Get a single `AssessmentSignature`. */
  assessmentSignatureByAssessmentId?: Maybe<AssessmentSignature>
  /** Reads a single `AssessmentSignature` using its globally unique `ID`. */
  assessmentSignatureById?: Maybe<AssessmentSignature>
  /** Fetches a list of `AssessmentSignature` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assessmentSignatureDocuments?: Maybe<AssessmentSignatureConnection>
  /** Reads and enables pagination through a set of `AssessmentSignature`. */
  assessmentSignatures?: Maybe<AssessmentSignatureConnection>
  /** Reads and enables pagination through a set of `Assessment`. */
  assessments?: Maybe<AssessmentConnection>
  /** Get a single `Assignment`. */
  assignment?: Maybe<Assignment>
  /** Reads a single `Assignment` using its globally unique `ID`. */
  assignmentById?: Maybe<Assignment>
  /** Fetches a list of `Assignment` documents, based on a `DocumentCheckpoint`. Used for data replication to the frontend. */
  assignmentDocuments?: Maybe<AssignmentConnection>
  /** Reads and enables pagination through a set of `Assignment`. */
  assignments?: Maybe<AssignmentConnection>
  /** Returns the current `authenticated` user `id`. */
  currentUserId?: Maybe<Scalars['UUID']['output']>
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  id: Scalars['ID']['output']
  /** Reports the `authenticated` state. */
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query
}

/** The root query type which gives access points into the data universe. */
export type QueryAppUserArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAppUserByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAppUserDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAppUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppUserCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppUserOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentAdditionalInfoArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentAdditionalInfoByAssessmentIdArgs = {
  assessmentId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentAdditionalInfoByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentAdditionalInfoDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentAdditionalInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentAdditionalInfoCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentAdditionalInfoOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentByAssignmentIdArgs = {
  assignmentId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDetailArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDetailByAssessmentIdArgs = {
  assessmentId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDetailByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDetailDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentDetailCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentDetailOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentMeasurementArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentMeasurementByAssessmentIdArgs = {
  assessmentId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentMeasurementByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentMeasurementDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentMeasurementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentMeasurementCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentMeasurementOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentSignatureArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentSignatureByAssessmentIdArgs = {
  assessmentId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentSignatureByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentSignatureDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentSignatureCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentSignatureOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssessmentCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssessmentOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssignmentArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssignmentByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAssignmentDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AssignmentCondition>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AssignmentOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input']
}

export enum RelationshipIssues {
  No = 'NO',
  Yes = 'YES',
}

export enum RelativesCareAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum RelativesCareDifficultiesList {
  BehaviorProblems = 'BEHAVIOR_PROBLEMS',
  CareObligations = 'CARE_OBLIGATIONS',
  FinancialRestrictions = 'FINANCIAL_RESTRICTIONS',
  HighLevelOfSupport = 'HIGH_LEVEL_OF_SUPPORT',
  LackOfAppreciation = 'LACK_OF_APPRECIATION',
  LackOfSupport = 'LACK_OF_SUPPORT',
  MobilityImpairment = 'MOBILITY_IMPAIRMENT',
  Other = 'OTHER',
  OverwhelmedWithCare = 'OVERWHELMED_WITH_CARE',
  OwnHealthProblems = 'OWN_HEALTH_PROBLEMS',
  PhysicalOverload = 'PHYSICAL_OVERLOAD',
  ProfessionalObligation = 'PROFESSIONAL_OBLIGATION',
}

export enum RelativesCareHelpFactorsList {
  GoodEquipment = 'GOOD_EQUIPMENT',
  GoodRelationship = 'GOOD_RELATIONSHIP',
  LeisureActivities = 'LEISURE_ACTIVITIES',
  NoFinancialWorries = 'NO_FINANCIAL_WORRIES',
  Other = 'OTHER',
  PositiveAttitude = 'POSITIVE_ATTITUDE',
  PrivateSupport = 'PRIVATE_SUPPORT',
  ProfessionalActivities = 'PROFESSIONAL_ACTIVITIES',
  ProfessionalSupport = 'PROFESSIONAL_SUPPORT',
}

export enum RelativesIssues {
  No = 'NO',
  Yes = 'YES',
}

export enum RelativesRelationshipIssues {
  No = 'NO',
  Yes = 'YES',
}

export enum RelevantContacts {
  DaughterInLawSonInLaw = 'DAUGHTER_IN_LAW_SON_IN_LAW',
  DaughterSon = 'DAUGHTER_SON',
  Friend = 'FRIEND',
  GeneralPractitioner = 'GENERAL_PRACTITIONER',
  Grandchild = 'GRANDCHILD',
  Neighbor = 'NEIGHBOR',
  NursingService = 'NURSING_SERVICE',
  Other = 'OTHER',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  SpecialistDoctor = 'SPECIALIST_DOCTOR',
  Supervisor = 'SUPERVISOR',
}

export enum ReportingResponsible {
  Other = 'OTHER',
  PersonInCare = 'PERSON_IN_CARE',
}

export enum Responsible {
  Other = 'OTHER',
  PersonInCare = 'PERSON_IN_CARE',
  ProfessionalCaregiver = 'PROFESSIONAL_CAREGIVER',
  Relatives = 'RELATIVES',
}

export enum SelfSufficiencyAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum SignsOfHealthRisk {
  No = 'NO',
  Yes = 'YES',
}

export enum SignsOfHealthRiskList {
  AlcoholSubstanceAbuse = 'ALCOHOL_SUBSTANCE_ABUSE',
  DecubitusUlcer = 'DECUBITUS_ULCER',
  Fall = 'FALL',
  Infection = 'INFECTION',
  LackOfFluids = 'LACK_OF_FLUIDS',
  Malnutrition = 'MALNUTRITION',
  MedicationError = 'MEDICATION_ERROR',
  SpecificRisks = 'SPECIFIC_RISKS',
}

export enum SocialContactAdvice {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum SocialContactDifficulties {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  Yes = 'YES',
}

export enum SocialContactDifficultiesList {
  ActivitiesParticipation = 'ACTIVITIES_PARTICIPATION',
  DailyRoutine = 'DAILY_ROUTINE',
  DirectContact = 'DIRECT_CONTACT',
  EventsParticipation = 'EVENTS_PARTICIPATION',
  KeepBusy = 'KEEP_BUSY',
  MakingPlans = 'MAKING_PLANS',
  Other = 'OTHER',
  OutsideContact = 'OUTSIDE_CONTACT',
}

export enum SocialContactSupport {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoDifficulties = 'NO_DIFFICULTIES',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export type StringField = {
  __typename?: 'StringField'
  fieldName?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** An input for mutations affecting `StringField` */
export type StringFieldInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription'
  streamAssessmentAdditionalInfos?: Maybe<AssessmentAdditionalInfoSubscriptionPayload>
  streamAssessmentDetails?: Maybe<AssessmentDetailSubscriptionPayload>
  streamAssessmentMeasurements?: Maybe<AssessmentMeasurementSubscriptionPayload>
  streamAssessmentSignatures?: Maybe<AssessmentSignatureSubscriptionPayload>
  streamAssessments?: Maybe<AssessmentSubscriptionPayload>
  streamAssignments?: Maybe<AssignmentSubscriptionPayload>
}

export enum SufficientActivitiesSupport {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoDifficulties = 'NO_DIFFICULTIES',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum SufficientMovingCare {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoDifficulties = 'NO_DIFFICULTIES',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum SufficientProblemsSupport {
  No = 'NO',
  NotKnown = 'NOT_KNOWN',
  NoProblems = 'NO_PROBLEMS',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum SupportSituationImproveMeasures {
  No = 'NO',
  Yes = 'YES',
}

export enum SupportSituationImproveMeasuresSuggestions {
  CareServicesInKind = 'CARE_SERVICES_IN_KIND',
  CombinationService = 'COMBINATION_SERVICE',
  DayAfterCare = 'DAY_AFTER_CARE',
  EverydayLifeSupport = 'EVERYDAY_LIFE_SUPPORT',
  HomeAdaptation = 'HOME_ADAPTATION',
  LeisureActivities = 'LEISURE_ACTIVITIES',
  NursingCourseTraining = 'NURSING_COURSE_TRAINING',
  Other = 'OTHER',
  PreventiveCare = 'PREVENTIVE_CARE',
  RehabilitationServices = 'REHABILITATION_SERVICES',
  RenewedCareSupport = 'RENEWED_CARE_SUPPORT',
  ShortTermCare = 'SHORT_TERM_CARE',
  TechnicalAids = 'TECHNICAL_AIDS',
}

export enum SupportWithCare {
  DaughterInLawSonInLaw = 'DAUGHTER_IN_LAW_SON_IN_LAW',
  DaughterSon = 'DAUGHTER_SON',
  Friend = 'FRIEND',
  Grandchild = 'GRANDCHILD',
  Neighbor = 'NEIGHBOR',
  No = 'NO',
  NursingService = 'NURSING_SERVICE',
  Other = 'OTHER',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  Supervisor = 'SUPERVISOR',
}

export enum Therapy {
  OccupationalTherapy = 'OCCUPATIONAL_THERAPY',
  Other = 'OTHER',
  Physiotherapy = 'PHYSIOTHERAPY',
  SpeechTherapy = 'SPEECH_THERAPY',
}

export enum TherapyNeeded {
  No = 'NO',
  Yes = 'YES',
}

export enum TrainingSubjects {
  ContinenceTraining = 'CONTINENCE_TRAINING',
  DealingWithCareAids = 'DEALING_WITH_CARE_AIDS',
  DementiaWorld = 'DEMENTIA_WORLD',
  EatingAndDrinking = 'EATING_AND_DRINKING',
  EmergenciesInHomeCare = 'EMERGENCIES_IN_HOME_CARE',
  Mobility = 'MOBILITY',
  OralCare = 'ORAL_CARE',
  PalliativeCare = 'PALLIATIVE_CARE',
  PersonalHygiene = 'PERSONAL_HYGIENE',
  PositioningAndTransfer = 'POSITIONING_AND_TRANSFER',
  PreventionAndSelfCareForRelatives = 'PREVENTION_AND_SELF_CARE_FOR_RELATIVES',
  PromotionOfPerception = 'PROMOTION_OF_PERCEPTION',
}

/** All input for the `updateAssessmentAdditionalInfoByAssessmentId` mutation. */
export type UpdateAssessmentAdditionalInfoByAssessmentIdInput = {
  assessmentId: Scalars['UUID']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentAdditionalInfo` being updated. */
  patch: AssessmentAdditionalInfoPatch
}

/** All input for the `updateAssessmentAdditionalInfoById` mutation. */
export type UpdateAssessmentAdditionalInfoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `AssessmentAdditionalInfo` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `AssessmentAdditionalInfo` being updated. */
  patch: AssessmentAdditionalInfoPatch
}

/** All input for the `updateAssessmentAdditionalInfo` mutation. */
export type UpdateAssessmentAdditionalInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentAdditionalInfo` being updated. */
  patch: AssessmentAdditionalInfoPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `AssessmentAdditionalInfo` mutation. */
export type UpdateAssessmentAdditionalInfoPayload = {
  __typename?: 'UpdateAssessmentAdditionalInfoPayload'
  /** The `AssessmentAdditionalInfo` that was updated by this mutation. */
  assessmentAdditionalInfo?: Maybe<AssessmentAdditionalInfo>
  /** An edge for our `AssessmentAdditionalInfo`. May be used by Relay 1. */
  assessmentAdditionalInfoEdge?: Maybe<AssessmentAdditionalInfoEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AssessmentAdditionalInfo` mutation. */
export type UpdateAssessmentAdditionalInfoPayloadAssessmentAdditionalInfoEdgeArgs =
  {
    orderBy?: Array<AssessmentAdditionalInfoOrderBy>
  }

/** All input for the `updateAssessmentByAssignmentId` mutation. */
export type UpdateAssessmentByAssignmentIdInput = {
  assignmentId: Scalars['UUID']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Assessment` being updated. */
  patch: AssessmentPatch
}

/** All input for the `updateAssessmentById` mutation. */
export type UpdateAssessmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Assessment` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Assessment` being updated. */
  patch: AssessmentPatch
}

/** All input for the `updateAssessmentDetailByAssessmentId` mutation. */
export type UpdateAssessmentDetailByAssessmentIdInput = {
  assessmentId: Scalars['UUID']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentDetail` being updated. */
  patch: AssessmentDetailPatch
}

/** All input for the `updateAssessmentDetailById` mutation. */
export type UpdateAssessmentDetailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `AssessmentDetail` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `AssessmentDetail` being updated. */
  patch: AssessmentDetailPatch
}

/** All input for the `updateAssessmentDetail` mutation. */
export type UpdateAssessmentDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentDetail` being updated. */
  patch: AssessmentDetailPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `AssessmentDetail` mutation. */
export type UpdateAssessmentDetailPayload = {
  __typename?: 'UpdateAssessmentDetailPayload'
  /** The `AssessmentDetail` that was updated by this mutation. */
  assessmentDetail?: Maybe<AssessmentDetail>
  /** An edge for our `AssessmentDetail`. May be used by Relay 1. */
  assessmentDetailEdge?: Maybe<AssessmentDetailEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AssessmentDetail` mutation. */
export type UpdateAssessmentDetailPayloadAssessmentDetailEdgeArgs = {
  orderBy?: Array<AssessmentDetailOrderBy>
}

/** All input for the `updateAssessment` mutation. */
export type UpdateAssessmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Assessment` being updated. */
  patch: AssessmentPatch
  rowId: Scalars['UUID']['input']
}

/** All input for the `updateAssessmentMeasurementByAssessmentId` mutation. */
export type UpdateAssessmentMeasurementByAssessmentIdInput = {
  assessmentId: Scalars['UUID']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentMeasurement` being updated. */
  patch: AssessmentMeasurementPatch
}

/** All input for the `updateAssessmentMeasurementById` mutation. */
export type UpdateAssessmentMeasurementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `AssessmentMeasurement` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `AssessmentMeasurement` being updated. */
  patch: AssessmentMeasurementPatch
}

/** All input for the `updateAssessmentMeasurement` mutation. */
export type UpdateAssessmentMeasurementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentMeasurement` being updated. */
  patch: AssessmentMeasurementPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `AssessmentMeasurement` mutation. */
export type UpdateAssessmentMeasurementPayload = {
  __typename?: 'UpdateAssessmentMeasurementPayload'
  /** The `AssessmentMeasurement` that was updated by this mutation. */
  assessmentMeasurement?: Maybe<AssessmentMeasurement>
  /** An edge for our `AssessmentMeasurement`. May be used by Relay 1. */
  assessmentMeasurementEdge?: Maybe<AssessmentMeasurementEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AssessmentMeasurement` mutation. */
export type UpdateAssessmentMeasurementPayloadAssessmentMeasurementEdgeArgs = {
  orderBy?: Array<AssessmentMeasurementOrderBy>
}

/** The output of our update `Assessment` mutation. */
export type UpdateAssessmentPayload = {
  __typename?: 'UpdateAssessmentPayload'
  /** The `Assessment` that was updated by this mutation. */
  assessment?: Maybe<Assessment>
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Assessment` mutation. */
export type UpdateAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: Array<AssessmentOrderBy>
}

/** All input for the `updateAssessmentSignatureByAssessmentId` mutation. */
export type UpdateAssessmentSignatureByAssessmentIdInput = {
  assessmentId: Scalars['UUID']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentSignature` being updated. */
  patch: AssessmentSignaturePatch
}

/** All input for the `updateAssessmentSignatureById` mutation. */
export type UpdateAssessmentSignatureByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `AssessmentSignature` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `AssessmentSignature` being updated. */
  patch: AssessmentSignaturePatch
}

/** All input for the `updateAssessmentSignature` mutation. */
export type UpdateAssessmentSignatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `AssessmentSignature` being updated. */
  patch: AssessmentSignaturePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `AssessmentSignature` mutation. */
export type UpdateAssessmentSignaturePayload = {
  __typename?: 'UpdateAssessmentSignaturePayload'
  /** The `AssessmentSignature` that was updated by this mutation. */
  assessmentSignature?: Maybe<AssessmentSignature>
  /** An edge for our `AssessmentSignature`. May be used by Relay 1. */
  assessmentSignatureEdge?: Maybe<AssessmentSignatureEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AssessmentSignature` mutation. */
export type UpdateAssessmentSignaturePayloadAssessmentSignatureEdgeArgs = {
  orderBy?: Array<AssessmentSignatureOrderBy>
}

/** All input for the `updateAssignmentById` mutation. */
export type UpdateAssignmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Assignment` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Assignment` being updated. */
  patch: AssignmentPatch
}

/** All input for the `updateAssignment` mutation. */
export type UpdateAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Assignment` being updated. */
  patch: AssignmentPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Assignment` mutation. */
export type UpdateAssignmentPayload = {
  __typename?: 'UpdateAssignmentPayload'
  /** The `Assignment` that was updated by this mutation. */
  assignment?: Maybe<Assignment>
  /** An edge for our `Assignment`. May be used by Relay 1. */
  assignmentEdge?: Maybe<AssignmentEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Assignment` mutation. */
export type UpdateAssignmentPayloadAssignmentEdgeArgs = {
  orderBy?: Array<AssignmentOrderBy>
}

export enum WithRelativesIssues {
  No = 'NO',
  Yes = 'YES',
}

export enum WithRelativesIssuesPersonInNeed {
  No = 'NO',
  Yes = 'YES',
}

export type AppUserDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
}>

export type AppUserDocumentsQuery = {
  __typename?: 'Query'
  appUserDocuments?: {
    __typename?: 'AppUserConnection'
    nodes: Array<{
      __typename?: 'AppUser'
      rowId: any
      updatedAt: any
      name: string
      emailAddress: string
    } | null>
  } | null
}

export type AssessmentFragment = {
  __typename?: 'Assessment'
  rowId: any
  updatedAt: any
  createdAt: any
  deleted: boolean
  state: AssessmentState
  patientId?: any | null
  consultationReason?: AssessmentConsultationReason | null
  consultationReasonOther?: string | null
  patientInsuranceName?: string | null
  patientInsuranceNumber?: string | null
  patientInsuranceType?: string | null
  patientGender?: Gender | null
  patientTitle?: string | null
  patientName?: string | null
  patientSurname?: string | null
  patientBirthdayAt?: any | null
  patientHasCareLevel?: PatientHasCareLevel | null
  careServiceType?: CareServiceType | null
  patientCareLevel?: CareLevel | null
  patientCareLevelNotes?: string | null
  patientFinancialSituation?: string | null
  patientPhoneNumber?: string | null
  patientDiseases?: string | null
  consultationAt?: any | null
  consultationBeginAt?: any | null
  consultationEndAt?: any | null
  consultationParticipants?: Array<ConsultationParticipant | null> | null
  consultationParticipantsOther?: string | null
  supportWithCare?: Array<SupportWithCare | null> | null
  supportWithCareOther?: string | null
  caregiverRegistered?: string | null
  medicalTreatment?: Array<MedicalTreatment | null> | null
  lifeForm?: Array<LifeForm | null> | null
  lifeFormOther?: string | null
  orders?: Array<Orders | null> | null
  relevantContacts?: Array<RelevantContacts | null> | null
  relevantContactsOther?: string | null
  assignmentId?: any | null
  patientAddress?: {
    __typename?: 'Address'
    street?: string | null
    houseNumber?: string | null
    postalCode?: string | null
    city?: string | null
  } | null
  contactPartner?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactDaughterSon?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactDaughterInLawSonInLaw?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactGrandchild?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactParent?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactFriend?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactNeighbor?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactSupervisor?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactGeneralPractitioner?: Array<{
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null> | null
  contactSpecialistDoctor?: Array<{
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null> | null
  contactNursingService?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
  contactOther?: {
    __typename?: 'Contact'
    name?: string | null
    address?: string | null
    phoneNumber?: string | null
    healthInsuranceFund?: string | null
    healthInsuranceNumber?: string | null
    healthInsuranceType?: string | null
  } | null
}

export type AssessmentDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssessmentDocumentsQuery = {
  __typename?: 'Query'
  assessmentDocuments?: {
    __typename?: 'AssessmentConnection'
    nodes: Array<{
      __typename?: 'Assessment'
      rowId: any
      updatedAt: any
      createdAt: any
      deleted: boolean
      state: AssessmentState
      patientId?: any | null
      consultationReason?: AssessmentConsultationReason | null
      consultationReasonOther?: string | null
      patientInsuranceName?: string | null
      patientInsuranceNumber?: string | null
      patientInsuranceType?: string | null
      patientGender?: Gender | null
      patientTitle?: string | null
      patientName?: string | null
      patientSurname?: string | null
      patientBirthdayAt?: any | null
      patientHasCareLevel?: PatientHasCareLevel | null
      careServiceType?: CareServiceType | null
      patientCareLevel?: CareLevel | null
      patientCareLevelNotes?: string | null
      patientFinancialSituation?: string | null
      patientPhoneNumber?: string | null
      patientDiseases?: string | null
      consultationAt?: any | null
      consultationBeginAt?: any | null
      consultationEndAt?: any | null
      consultationParticipants?: Array<ConsultationParticipant | null> | null
      consultationParticipantsOther?: string | null
      supportWithCare?: Array<SupportWithCare | null> | null
      supportWithCareOther?: string | null
      caregiverRegistered?: string | null
      medicalTreatment?: Array<MedicalTreatment | null> | null
      lifeForm?: Array<LifeForm | null> | null
      lifeFormOther?: string | null
      orders?: Array<Orders | null> | null
      relevantContacts?: Array<RelevantContacts | null> | null
      relevantContactsOther?: string | null
      assignmentId?: any | null
      patientAddress?: {
        __typename?: 'Address'
        street?: string | null
        houseNumber?: string | null
        postalCode?: string | null
        city?: string | null
      } | null
      contactPartner?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterSon?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterInLawSonInLaw?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGrandchild?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactParent?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactFriend?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactNeighbor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactSupervisor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGeneralPractitioner?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactSpecialistDoctor?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactNursingService?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactOther?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
    } | null>
  } | null
}

export type StreamAssessmentSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssessmentSubscription = {
  __typename?: 'Subscription'
  streamAssessments?: {
    __typename?: 'AssessmentSubscriptionPayload'
    assessment?: {
      __typename?: 'Assessment'
      rowId: any
      updatedAt: any
      createdAt: any
      deleted: boolean
      state: AssessmentState
      patientId?: any | null
      consultationReason?: AssessmentConsultationReason | null
      consultationReasonOther?: string | null
      patientInsuranceName?: string | null
      patientInsuranceNumber?: string | null
      patientInsuranceType?: string | null
      patientGender?: Gender | null
      patientTitle?: string | null
      patientName?: string | null
      patientSurname?: string | null
      patientBirthdayAt?: any | null
      patientHasCareLevel?: PatientHasCareLevel | null
      careServiceType?: CareServiceType | null
      patientCareLevel?: CareLevel | null
      patientCareLevelNotes?: string | null
      patientFinancialSituation?: string | null
      patientPhoneNumber?: string | null
      patientDiseases?: string | null
      consultationAt?: any | null
      consultationBeginAt?: any | null
      consultationEndAt?: any | null
      consultationParticipants?: Array<ConsultationParticipant | null> | null
      consultationParticipantsOther?: string | null
      supportWithCare?: Array<SupportWithCare | null> | null
      supportWithCareOther?: string | null
      caregiverRegistered?: string | null
      medicalTreatment?: Array<MedicalTreatment | null> | null
      lifeForm?: Array<LifeForm | null> | null
      lifeFormOther?: string | null
      orders?: Array<Orders | null> | null
      relevantContacts?: Array<RelevantContacts | null> | null
      relevantContactsOther?: string | null
      assignmentId?: any | null
      patientAddress?: {
        __typename?: 'Address'
        street?: string | null
        houseNumber?: string | null
        postalCode?: string | null
        city?: string | null
      } | null
      contactPartner?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterSon?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterInLawSonInLaw?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGrandchild?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactParent?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactFriend?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactNeighbor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactSupervisor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGeneralPractitioner?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactSpecialistDoctor?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactNursingService?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactOther?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
    } | null
  } | null
}

export type AddAssessmentMutationVariables = Exact<{
  rows: Array<InputMaybe<AssessmentInput>> | InputMaybe<AssessmentInput>
}>

export type AddAssessmentMutation = {
  __typename?: 'Mutation'
  assessmentReplicate?: {
    __typename?: 'AssessmentReplicatePayload'
    result?: Array<{
      __typename?: 'Assessment'
      rowId: any
      updatedAt: any
      createdAt: any
      deleted: boolean
      state: AssessmentState
      patientId?: any | null
      consultationReason?: AssessmentConsultationReason | null
      consultationReasonOther?: string | null
      patientInsuranceName?: string | null
      patientInsuranceNumber?: string | null
      patientInsuranceType?: string | null
      patientGender?: Gender | null
      patientTitle?: string | null
      patientName?: string | null
      patientSurname?: string | null
      patientBirthdayAt?: any | null
      patientHasCareLevel?: PatientHasCareLevel | null
      careServiceType?: CareServiceType | null
      patientCareLevel?: CareLevel | null
      patientCareLevelNotes?: string | null
      patientFinancialSituation?: string | null
      patientPhoneNumber?: string | null
      patientDiseases?: string | null
      consultationAt?: any | null
      consultationBeginAt?: any | null
      consultationEndAt?: any | null
      consultationParticipants?: Array<ConsultationParticipant | null> | null
      consultationParticipantsOther?: string | null
      supportWithCare?: Array<SupportWithCare | null> | null
      supportWithCareOther?: string | null
      caregiverRegistered?: string | null
      medicalTreatment?: Array<MedicalTreatment | null> | null
      lifeForm?: Array<LifeForm | null> | null
      lifeFormOther?: string | null
      orders?: Array<Orders | null> | null
      relevantContacts?: Array<RelevantContacts | null> | null
      relevantContactsOther?: string | null
      assignmentId?: any | null
      patientAddress?: {
        __typename?: 'Address'
        street?: string | null
        houseNumber?: string | null
        postalCode?: string | null
        city?: string | null
      } | null
      contactPartner?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterSon?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactDaughterInLawSonInLaw?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGrandchild?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactParent?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactFriend?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactNeighbor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactSupervisor?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactGeneralPractitioner?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactSpecialistDoctor?: Array<{
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null> | null
      contactNursingService?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
      contactOther?: {
        __typename?: 'Contact'
        name?: string | null
        address?: string | null
        phoneNumber?: string | null
        healthInsuranceFund?: string | null
        healthInsuranceNumber?: string | null
        healthInsuranceType?: string | null
      } | null
    } | null> | null
  } | null
}

export type AssessmentAdditionalInfoFragment = {
  __typename?: 'AssessmentAdditionalInfo'
  rowId: any
  updatedAt: any
  deleted: boolean
  assessmentId?: any | null
  careChangesSuggestionsPersonInNeedOfCare?: string | null
  careChangesSuggestionsRelativeCaregiver?: string | null
  careImprovementsSuggestionsPersonInNeedOfCare?: string | null
  careImprovementsSuggestionsRelativeCaregiver?: string | null
  differentThanUsualPersonInNeedOfCare?: string | null
  differentThanUsualRelativeCaregiver?: string | null
  otherCommentsPersonInNeedOfCare?: string | null
  otherCommentsRelativeCaregiver?: string | null
  agreedObjectives?: string | null
  agreementsOnNextSteps?: string | null
  openQuestions?: string | null
  supportSituationCaregiverPerspective?: string | null
  supportSituationCounselorPerspective?: string | null
  supportIsEnsured?: AssessmentSupportIsEnsured | null
  supportIsEnsuredReason?: string | null
  supportSituationImproveMeasures?: SupportSituationImproveMeasures | null
  supportSituationImproveMeasuresSuggestions?: Array<SupportSituationImproveMeasuresSuggestions | null> | null
  supportSituationImproveMeasuresSuggestionsOtherComments?: string | null
  counselingViaVideoConference?: CounselingViaVideoConference | null
  careCounselingIndicatedSection7A?: CareCounselingIndicatedSection7A | null
  careCounselingRequestedSection7A?: CareCounselingRequestedSection7A | null
  consentToShareCareSupportInformation?: ConsentToShareCareSupportInformation | null
  consentToShareImprovementRecommendations?: ConsentToShareImprovementRecommendations | null
  consentToSiteInspectionAndToShareInformation?: ConsentToSiteInspectionAndToShareInformation | null
  consentToProcessingCounselingResultsSection7A?: ConsentToProcessingCounselingResultsSection7A | null
  consentToProcessingByInsuranceSection45?: ConsentToProcessingByInsuranceSection45 | null
  insuranceName?: string | null
  locationAndDateSection373?: string | null
  protocolDispatch?: ProtocolDispatch | null
  protocolDispatchEmail?: string | null
  trainingSubject?: TrainingSubjects | null
  billablePerson?: ConsultationParticipant | null
}

export type AssessmentAdditionalInfoDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssessmentAdditionalInfoDocumentsQuery = {
  __typename?: 'Query'
  assessmentAdditionalInfoDocuments?: {
    __typename?: 'AssessmentAdditionalInfoConnection'
    nodes: Array<{
      __typename?: 'AssessmentAdditionalInfo'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      careChangesSuggestionsPersonInNeedOfCare?: string | null
      careChangesSuggestionsRelativeCaregiver?: string | null
      careImprovementsSuggestionsPersonInNeedOfCare?: string | null
      careImprovementsSuggestionsRelativeCaregiver?: string | null
      differentThanUsualPersonInNeedOfCare?: string | null
      differentThanUsualRelativeCaregiver?: string | null
      otherCommentsPersonInNeedOfCare?: string | null
      otherCommentsRelativeCaregiver?: string | null
      agreedObjectives?: string | null
      agreementsOnNextSteps?: string | null
      openQuestions?: string | null
      supportSituationCaregiverPerspective?: string | null
      supportSituationCounselorPerspective?: string | null
      supportIsEnsured?: AssessmentSupportIsEnsured | null
      supportIsEnsuredReason?: string | null
      supportSituationImproveMeasures?: SupportSituationImproveMeasures | null
      supportSituationImproveMeasuresSuggestions?: Array<SupportSituationImproveMeasuresSuggestions | null> | null
      supportSituationImproveMeasuresSuggestionsOtherComments?: string | null
      counselingViaVideoConference?: CounselingViaVideoConference | null
      careCounselingIndicatedSection7A?: CareCounselingIndicatedSection7A | null
      careCounselingRequestedSection7A?: CareCounselingRequestedSection7A | null
      consentToShareCareSupportInformation?: ConsentToShareCareSupportInformation | null
      consentToShareImprovementRecommendations?: ConsentToShareImprovementRecommendations | null
      consentToSiteInspectionAndToShareInformation?: ConsentToSiteInspectionAndToShareInformation | null
      consentToProcessingCounselingResultsSection7A?: ConsentToProcessingCounselingResultsSection7A | null
      consentToProcessingByInsuranceSection45?: ConsentToProcessingByInsuranceSection45 | null
      insuranceName?: string | null
      locationAndDateSection373?: string | null
      protocolDispatch?: ProtocolDispatch | null
      protocolDispatchEmail?: string | null
      trainingSubject?: TrainingSubjects | null
      billablePerson?: ConsultationParticipant | null
    } | null>
  } | null
}

export type StreamAssessmentAdditionalInfosSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssessmentAdditionalInfosSubscription = {
  __typename?: 'Subscription'
  streamAssessmentAdditionalInfos?: {
    __typename?: 'AssessmentAdditionalInfoSubscriptionPayload'
    assessmentAdditionalInfo?: {
      __typename?: 'AssessmentAdditionalInfo'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      careChangesSuggestionsPersonInNeedOfCare?: string | null
      careChangesSuggestionsRelativeCaregiver?: string | null
      careImprovementsSuggestionsPersonInNeedOfCare?: string | null
      careImprovementsSuggestionsRelativeCaregiver?: string | null
      differentThanUsualPersonInNeedOfCare?: string | null
      differentThanUsualRelativeCaregiver?: string | null
      otherCommentsPersonInNeedOfCare?: string | null
      otherCommentsRelativeCaregiver?: string | null
      agreedObjectives?: string | null
      agreementsOnNextSteps?: string | null
      openQuestions?: string | null
      supportSituationCaregiverPerspective?: string | null
      supportSituationCounselorPerspective?: string | null
      supportIsEnsured?: AssessmentSupportIsEnsured | null
      supportIsEnsuredReason?: string | null
      supportSituationImproveMeasures?: SupportSituationImproveMeasures | null
      supportSituationImproveMeasuresSuggestions?: Array<SupportSituationImproveMeasuresSuggestions | null> | null
      supportSituationImproveMeasuresSuggestionsOtherComments?: string | null
      counselingViaVideoConference?: CounselingViaVideoConference | null
      careCounselingIndicatedSection7A?: CareCounselingIndicatedSection7A | null
      careCounselingRequestedSection7A?: CareCounselingRequestedSection7A | null
      consentToShareCareSupportInformation?: ConsentToShareCareSupportInformation | null
      consentToShareImprovementRecommendations?: ConsentToShareImprovementRecommendations | null
      consentToSiteInspectionAndToShareInformation?: ConsentToSiteInspectionAndToShareInformation | null
      consentToProcessingCounselingResultsSection7A?: ConsentToProcessingCounselingResultsSection7A | null
      consentToProcessingByInsuranceSection45?: ConsentToProcessingByInsuranceSection45 | null
      insuranceName?: string | null
      locationAndDateSection373?: string | null
      protocolDispatch?: ProtocolDispatch | null
      protocolDispatchEmail?: string | null
      trainingSubject?: TrainingSubjects | null
      billablePerson?: ConsultationParticipant | null
    } | null
  } | null
}

export type AddAssessmentAdditionalInfoMutationVariables = Exact<{
  rows:
    | Array<InputMaybe<AssessmentAdditionalInfoInput>>
    | InputMaybe<AssessmentAdditionalInfoInput>
}>

export type AddAssessmentAdditionalInfoMutation = {
  __typename?: 'Mutation'
  assessmentAdditionalInfoReplicate?: {
    __typename?: 'AssessmentAdditionalInfoReplicatePayload'
    result?: Array<{
      __typename?: 'AssessmentAdditionalInfo'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      careChangesSuggestionsPersonInNeedOfCare?: string | null
      careChangesSuggestionsRelativeCaregiver?: string | null
      careImprovementsSuggestionsPersonInNeedOfCare?: string | null
      careImprovementsSuggestionsRelativeCaregiver?: string | null
      differentThanUsualPersonInNeedOfCare?: string | null
      differentThanUsualRelativeCaregiver?: string | null
      otherCommentsPersonInNeedOfCare?: string | null
      otherCommentsRelativeCaregiver?: string | null
      agreedObjectives?: string | null
      agreementsOnNextSteps?: string | null
      openQuestions?: string | null
      supportSituationCaregiverPerspective?: string | null
      supportSituationCounselorPerspective?: string | null
      supportIsEnsured?: AssessmentSupportIsEnsured | null
      supportIsEnsuredReason?: string | null
      supportSituationImproveMeasures?: SupportSituationImproveMeasures | null
      supportSituationImproveMeasuresSuggestions?: Array<SupportSituationImproveMeasuresSuggestions | null> | null
      supportSituationImproveMeasuresSuggestionsOtherComments?: string | null
      counselingViaVideoConference?: CounselingViaVideoConference | null
      careCounselingIndicatedSection7A?: CareCounselingIndicatedSection7A | null
      careCounselingRequestedSection7A?: CareCounselingRequestedSection7A | null
      consentToShareCareSupportInformation?: ConsentToShareCareSupportInformation | null
      consentToShareImprovementRecommendations?: ConsentToShareImprovementRecommendations | null
      consentToSiteInspectionAndToShareInformation?: ConsentToSiteInspectionAndToShareInformation | null
      consentToProcessingCounselingResultsSection7A?: ConsentToProcessingCounselingResultsSection7A | null
      consentToProcessingByInsuranceSection45?: ConsentToProcessingByInsuranceSection45 | null
      insuranceName?: string | null
      locationAndDateSection373?: string | null
      protocolDispatch?: ProtocolDispatch | null
      protocolDispatchEmail?: string | null
      trainingSubject?: TrainingSubjects | null
      billablePerson?: ConsultationParticipant | null
    } | null> | null
  } | null
}

export type AssessmentDetailFragment = {
  __typename?: 'AssessmentDetail'
  rowId: any
  updatedAt: any
  deleted: boolean
  assessmentId?: any | null
  reportingResponsible?: ReportingResponsible | null
  assistanceNeeded?: AssistanceNeeded | null
  assistances?: Array<Assistance | null> | null
  assistancesMobilityComments?: string | null
  assistancesPositioningInBedComments?: string | null
  assistancesPersonalHygieneComments?: string | null
  assistancesDevicesToSupportExcretionComments?: string | null
  assistancesPhysicalAidComments?: string | null
  assistancesDevicesToFoodIntakeComments?: string | null
  assistancesOtherComments?: string | null
  assistanceServicesNeeded?: AssistanceServiceNeeded | null
  assistanceServices?: Array<AssistanceService | null> | null
  assistanceServicesOtherComments?: string | null
  otherAssistancesNeeded?: OtherAssistanceNeeded | null
  otherAssistancesService?: Array<OtherAssistanceService | null> | null
  otherAssistancesServiceOtherComments?: string | null
  therapiesNeeded?: TherapyNeeded | null
  therapies?: Array<Therapy | null> | null
  therapiesOtherComments?: string | null
  careWellOrganized?: CareWellOrganized | null
  organizationCareAdviceNeeded?: OrganizationCareAdviceNeeded | null
  organizationCareAdviceTopics?: string | null
  organizationCareAdviceComments?: string | null
  movingDifficulties?: MovingDifficulties | null
  movingDifficultiesActivity?: Array<MovingDifficultiesActivity | null> | null
  movingDifficultiesActivityOtherComments?: string | null
  sufficientMovingCare?: SufficientMovingCare | null
  fallenCareRecently?: FallenCareRecently | null
  generallyPhysicalActive?: GenerallyPhysicalActive | null
  mobilityAreaAdvice?: MobilityAreaAdvice | null
  mobilityAreaAdviceTopics?: string | null
  mobilityAreaAdviceComments?: string | null
  mentalDifficulties?: MentalDifficulties | null
  mentalDifficultiesList?: Array<MentalDifficultiesList | null> | null
  mentalDifficultiesListOtherComments?: string | null
  behaviorChanges?: BehaviorChanges | null
  behaviorChangesList?: Array<BehaviorChangesList | null> | null
  behaviorChangesListOtherComments?: string | null
  changesSupportNeeded?: ChangesSupportNeeded | null
  depressedRecently?: DepressedRecently | null
  lessEnjoyment?: LessEnjoyment | null
  mentalHealthCounseling?: MentalHealthCounseling | null
  mentalHealthCounselingTopics?: string | null
  mentalHealthCounselingComments?: string | null
  physicalProblems?: PhysicalProblems | null
  physicalProblemsList?: Array<PhysicalProblemsList | null> | null
  physicalProblemsListOtherComments?: string | null
  diseaseMeasures?: DiseaseMeasures | null
  diseaseMeasuresList?: Array<DiseaseMeasuresList | null> | null
  diseaseMeasuresListOtherComments?: string | null
  sufficientProblemsSupport?: SufficientProblemsSupport | null
  hospitalizedRecently?: HospitalizedRecently | null
  signsOfHealthRisk?: SignsOfHealthRisk | null
  signsOfHealthRiskList?: Array<SignsOfHealthRiskList | null> | null
  signsOfHealthRiskListSpecificRisksComments?: string | null
  physicalHealthAdvice?: PhysicalHealthAdvice | null
  physicalHealthAdviceTopics?: string | null
  physicalHealthAdviceComments?: string | null
  activitySupport?: ActivitySupport | null
  activitySupportList?: Array<ActivitySupportList | null> | null
  activitySupportListHygieneOtherComments?: string | null
  activitySupportListDressingOtherComments?: string | null
  activitySupportListNutritionOtherComments?: string | null
  activitySupportListExcretionOtherComments?: string | null
  activitySupportListHousekeepingOtherComments?: string | null
  sufficientActivitiesSupport?: SufficientActivitiesSupport | null
  selfSufficiencyAdvice?: SelfSufficiencyAdvice | null
  selfSufficiencyAdviceTopics?: string | null
  selfSufficiencyAdviceComments?: string | null
  socialContactDifficulties?: SocialContactDifficulties | null
  socialContactDifficultiesList?: Array<SocialContactDifficultiesList | null> | null
  socialContactDifficultiesListOtherComments?: string | null
  socialContactSupport?: SocialContactSupport | null
  socialContactAdvice?: SocialContactAdvice | null
  socialContactAdviceTopics?: string | null
  socialContactAdviceComments?: string | null
  livingEnvironmentProblems?: LivingEnvironmentProblems | null
  livingEnvironmentProblemsList?: Array<LivingEnvironmentProblemsList | null> | null
  livingEnvironmentProblemsListOtherComments?: string | null
  livingEnvironmentSupport?: LivingEnvironmentSupport | null
  livingEnvironmentAdvice?: LivingEnvironmentAdvice | null
  livingEnvironmentAdviceTopics?: string | null
  livingEnvironmentAdviceComments?: string | null
  relationshipIssues?: RelationshipIssues | null
  withRelativesIssues?: WithRelativesIssues | null
  withRelativesIssuesPersonInNeed?: WithRelativesIssuesPersonInNeed | null
  relativesRelationshipIssues?: RelativesRelationshipIssues | null
  relativesIssues?: RelativesIssues | null
  careIssues?: CareIssues | null
  careRelationshipAdvice?: CareRelationshipAdvice | null
  careRelationshipAdviceTopics?: string | null
  careRelationshipAdviceComments?: string | null
  careSituation?: CareSituation | null
  relativesCareDifficultiesList?: Array<RelativesCareDifficultiesList | null> | null
  relativesCareDifficultiesListOtherComments?: string | null
  relativesCareHelpFactorsList?: Array<RelativesCareHelpFactorsList | null> | null
  relativesCareHelpFactorsListOtherComments?: string | null
  relativesCareAdvice?: RelativesCareAdvice | null
  relativesCareAdviceTopics?: string | null
  relativesCareAdviceComments?: string | null
  diseaseMeasuresResponsible?: {
    __typename?: 'MeasureResponsible'
    medication?: Array<Responsible | null> | null
    medicationOtherComments?: string | null
    bodyConditionMonitoring?: Array<Responsible | null> | null
    bodyConditionMonitoringOtherComments?: string | null
    handlingBodyHuggingAids?: Array<Responsible | null> | null
    handlingBodyHuggingAidsOtherComments?: string | null
    dressingWoundsCare?: Array<Responsible | null> | null
    dressingWoundsCareOtherComments?: string | null
    therapy?: Array<Responsible | null> | null
    therapyOtherComments?: string | null
    doctorVisits?: Array<Responsible | null> | null
    doctorVisitsOtherComments?: string | null
    dietDueToIllness?: Array<Responsible | null> | null
    dietDueToIllnessOtherComments?: string | null
    other?: Array<Responsible | null> | null
    otherOtherComments?: string | null
  } | null
  activitySupportPerson?: {
    __typename?: 'ActivitySupportPerson'
    washUpperBody?: Array<Responsible | null> | null
    washUpperBodyOtherComments?: string | null
    combingShaving?: Array<Responsible | null> | null
    combingShavingOtherComments?: string | null
    oralCare?: Array<Responsible | null> | null
    oralCareOtherComments?: string | null
    washIntimateArea?: Array<Responsible | null> | null
    washIntimateAreaOtherComments?: string | null
    shower?: Array<Responsible | null> | null
    showerOtherComments?: string | null
    hairWash?: Array<Responsible | null> | null
    hairWashOtherComments?: string | null
    hygieneOther?: Array<Responsible | null> | null
    hygieneOtherOtherComments?: string | null
    dressingUpperBody?: Array<Responsible | null> | null
    dressingUpperBodyOtherComments?: string | null
    dressingLowerBody?: Array<Responsible | null> | null
    dressingLowerBodyOtherComments?: string | null
    dressingOther?: Array<Responsible | null> | null
    dressingOtherOtherComments?: string | null
    drink?: Array<Responsible | null> | null
    drinkOtherComments?: string | null
    eat?: Array<Responsible | null> | null
    eatOtherComments?: string | null
    nutritionOther?: Array<Responsible | null> | null
    nutritionOtherOtherComments?: string | null
    toilet?: Array<Responsible | null> | null
    toiletOtherComments?: string | null
    urinaryIncontinence?: Array<Responsible | null> | null
    urinaryIncontinenceOtherComments?: string | null
    fecalIncontinence?: Array<Responsible | null> | null
    fecalIncontinenceOtherComments?: string | null
    excretionOther?: Array<Responsible | null> | null
    excretionOtherOtherComments?: string | null
    shopping?: Array<Responsible | null> | null
    shoppingOtherComments?: string | null
    cooking?: Array<Responsible | null> | null
    cookingOtherComments?: string | null
    cleaning?: Array<Responsible | null> | null
    cleaningOtherComments?: string | null
    housekeepingOther?: Array<Responsible | null> | null
    housekeepingOtherOtherComments?: string | null
  } | null
}

export type AssessmentDetailDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssessmentDetailDocumentsQuery = {
  __typename?: 'Query'
  assessmentDetailDocuments?: {
    __typename?: 'AssessmentDetailConnection'
    nodes: Array<{
      __typename?: 'AssessmentDetail'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      reportingResponsible?: ReportingResponsible | null
      assistanceNeeded?: AssistanceNeeded | null
      assistances?: Array<Assistance | null> | null
      assistancesMobilityComments?: string | null
      assistancesPositioningInBedComments?: string | null
      assistancesPersonalHygieneComments?: string | null
      assistancesDevicesToSupportExcretionComments?: string | null
      assistancesPhysicalAidComments?: string | null
      assistancesDevicesToFoodIntakeComments?: string | null
      assistancesOtherComments?: string | null
      assistanceServicesNeeded?: AssistanceServiceNeeded | null
      assistanceServices?: Array<AssistanceService | null> | null
      assistanceServicesOtherComments?: string | null
      otherAssistancesNeeded?: OtherAssistanceNeeded | null
      otherAssistancesService?: Array<OtherAssistanceService | null> | null
      otherAssistancesServiceOtherComments?: string | null
      therapiesNeeded?: TherapyNeeded | null
      therapies?: Array<Therapy | null> | null
      therapiesOtherComments?: string | null
      careWellOrganized?: CareWellOrganized | null
      organizationCareAdviceNeeded?: OrganizationCareAdviceNeeded | null
      organizationCareAdviceTopics?: string | null
      organizationCareAdviceComments?: string | null
      movingDifficulties?: MovingDifficulties | null
      movingDifficultiesActivity?: Array<MovingDifficultiesActivity | null> | null
      movingDifficultiesActivityOtherComments?: string | null
      sufficientMovingCare?: SufficientMovingCare | null
      fallenCareRecently?: FallenCareRecently | null
      generallyPhysicalActive?: GenerallyPhysicalActive | null
      mobilityAreaAdvice?: MobilityAreaAdvice | null
      mobilityAreaAdviceTopics?: string | null
      mobilityAreaAdviceComments?: string | null
      mentalDifficulties?: MentalDifficulties | null
      mentalDifficultiesList?: Array<MentalDifficultiesList | null> | null
      mentalDifficultiesListOtherComments?: string | null
      behaviorChanges?: BehaviorChanges | null
      behaviorChangesList?: Array<BehaviorChangesList | null> | null
      behaviorChangesListOtherComments?: string | null
      changesSupportNeeded?: ChangesSupportNeeded | null
      depressedRecently?: DepressedRecently | null
      lessEnjoyment?: LessEnjoyment | null
      mentalHealthCounseling?: MentalHealthCounseling | null
      mentalHealthCounselingTopics?: string | null
      mentalHealthCounselingComments?: string | null
      physicalProblems?: PhysicalProblems | null
      physicalProblemsList?: Array<PhysicalProblemsList | null> | null
      physicalProblemsListOtherComments?: string | null
      diseaseMeasures?: DiseaseMeasures | null
      diseaseMeasuresList?: Array<DiseaseMeasuresList | null> | null
      diseaseMeasuresListOtherComments?: string | null
      sufficientProblemsSupport?: SufficientProblemsSupport | null
      hospitalizedRecently?: HospitalizedRecently | null
      signsOfHealthRisk?: SignsOfHealthRisk | null
      signsOfHealthRiskList?: Array<SignsOfHealthRiskList | null> | null
      signsOfHealthRiskListSpecificRisksComments?: string | null
      physicalHealthAdvice?: PhysicalHealthAdvice | null
      physicalHealthAdviceTopics?: string | null
      physicalHealthAdviceComments?: string | null
      activitySupport?: ActivitySupport | null
      activitySupportList?: Array<ActivitySupportList | null> | null
      activitySupportListHygieneOtherComments?: string | null
      activitySupportListDressingOtherComments?: string | null
      activitySupportListNutritionOtherComments?: string | null
      activitySupportListExcretionOtherComments?: string | null
      activitySupportListHousekeepingOtherComments?: string | null
      sufficientActivitiesSupport?: SufficientActivitiesSupport | null
      selfSufficiencyAdvice?: SelfSufficiencyAdvice | null
      selfSufficiencyAdviceTopics?: string | null
      selfSufficiencyAdviceComments?: string | null
      socialContactDifficulties?: SocialContactDifficulties | null
      socialContactDifficultiesList?: Array<SocialContactDifficultiesList | null> | null
      socialContactDifficultiesListOtherComments?: string | null
      socialContactSupport?: SocialContactSupport | null
      socialContactAdvice?: SocialContactAdvice | null
      socialContactAdviceTopics?: string | null
      socialContactAdviceComments?: string | null
      livingEnvironmentProblems?: LivingEnvironmentProblems | null
      livingEnvironmentProblemsList?: Array<LivingEnvironmentProblemsList | null> | null
      livingEnvironmentProblemsListOtherComments?: string | null
      livingEnvironmentSupport?: LivingEnvironmentSupport | null
      livingEnvironmentAdvice?: LivingEnvironmentAdvice | null
      livingEnvironmentAdviceTopics?: string | null
      livingEnvironmentAdviceComments?: string | null
      relationshipIssues?: RelationshipIssues | null
      withRelativesIssues?: WithRelativesIssues | null
      withRelativesIssuesPersonInNeed?: WithRelativesIssuesPersonInNeed | null
      relativesRelationshipIssues?: RelativesRelationshipIssues | null
      relativesIssues?: RelativesIssues | null
      careIssues?: CareIssues | null
      careRelationshipAdvice?: CareRelationshipAdvice | null
      careRelationshipAdviceTopics?: string | null
      careRelationshipAdviceComments?: string | null
      careSituation?: CareSituation | null
      relativesCareDifficultiesList?: Array<RelativesCareDifficultiesList | null> | null
      relativesCareDifficultiesListOtherComments?: string | null
      relativesCareHelpFactorsList?: Array<RelativesCareHelpFactorsList | null> | null
      relativesCareHelpFactorsListOtherComments?: string | null
      relativesCareAdvice?: RelativesCareAdvice | null
      relativesCareAdviceTopics?: string | null
      relativesCareAdviceComments?: string | null
      diseaseMeasuresResponsible?: {
        __typename?: 'MeasureResponsible'
        medication?: Array<Responsible | null> | null
        medicationOtherComments?: string | null
        bodyConditionMonitoring?: Array<Responsible | null> | null
        bodyConditionMonitoringOtherComments?: string | null
        handlingBodyHuggingAids?: Array<Responsible | null> | null
        handlingBodyHuggingAidsOtherComments?: string | null
        dressingWoundsCare?: Array<Responsible | null> | null
        dressingWoundsCareOtherComments?: string | null
        therapy?: Array<Responsible | null> | null
        therapyOtherComments?: string | null
        doctorVisits?: Array<Responsible | null> | null
        doctorVisitsOtherComments?: string | null
        dietDueToIllness?: Array<Responsible | null> | null
        dietDueToIllnessOtherComments?: string | null
        other?: Array<Responsible | null> | null
        otherOtherComments?: string | null
      } | null
      activitySupportPerson?: {
        __typename?: 'ActivitySupportPerson'
        washUpperBody?: Array<Responsible | null> | null
        washUpperBodyOtherComments?: string | null
        combingShaving?: Array<Responsible | null> | null
        combingShavingOtherComments?: string | null
        oralCare?: Array<Responsible | null> | null
        oralCareOtherComments?: string | null
        washIntimateArea?: Array<Responsible | null> | null
        washIntimateAreaOtherComments?: string | null
        shower?: Array<Responsible | null> | null
        showerOtherComments?: string | null
        hairWash?: Array<Responsible | null> | null
        hairWashOtherComments?: string | null
        hygieneOther?: Array<Responsible | null> | null
        hygieneOtherOtherComments?: string | null
        dressingUpperBody?: Array<Responsible | null> | null
        dressingUpperBodyOtherComments?: string | null
        dressingLowerBody?: Array<Responsible | null> | null
        dressingLowerBodyOtherComments?: string | null
        dressingOther?: Array<Responsible | null> | null
        dressingOtherOtherComments?: string | null
        drink?: Array<Responsible | null> | null
        drinkOtherComments?: string | null
        eat?: Array<Responsible | null> | null
        eatOtherComments?: string | null
        nutritionOther?: Array<Responsible | null> | null
        nutritionOtherOtherComments?: string | null
        toilet?: Array<Responsible | null> | null
        toiletOtherComments?: string | null
        urinaryIncontinence?: Array<Responsible | null> | null
        urinaryIncontinenceOtherComments?: string | null
        fecalIncontinence?: Array<Responsible | null> | null
        fecalIncontinenceOtherComments?: string | null
        excretionOther?: Array<Responsible | null> | null
        excretionOtherOtherComments?: string | null
        shopping?: Array<Responsible | null> | null
        shoppingOtherComments?: string | null
        cooking?: Array<Responsible | null> | null
        cookingOtherComments?: string | null
        cleaning?: Array<Responsible | null> | null
        cleaningOtherComments?: string | null
        housekeepingOther?: Array<Responsible | null> | null
        housekeepingOtherOtherComments?: string | null
      } | null
    } | null>
  } | null
}

export type StreamAssessmentDetailsSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssessmentDetailsSubscription = {
  __typename?: 'Subscription'
  streamAssessmentDetails?: {
    __typename?: 'AssessmentDetailSubscriptionPayload'
    assessmentDetail?: {
      __typename?: 'AssessmentDetail'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      reportingResponsible?: ReportingResponsible | null
      assistanceNeeded?: AssistanceNeeded | null
      assistances?: Array<Assistance | null> | null
      assistancesMobilityComments?: string | null
      assistancesPositioningInBedComments?: string | null
      assistancesPersonalHygieneComments?: string | null
      assistancesDevicesToSupportExcretionComments?: string | null
      assistancesPhysicalAidComments?: string | null
      assistancesDevicesToFoodIntakeComments?: string | null
      assistancesOtherComments?: string | null
      assistanceServicesNeeded?: AssistanceServiceNeeded | null
      assistanceServices?: Array<AssistanceService | null> | null
      assistanceServicesOtherComments?: string | null
      otherAssistancesNeeded?: OtherAssistanceNeeded | null
      otherAssistancesService?: Array<OtherAssistanceService | null> | null
      otherAssistancesServiceOtherComments?: string | null
      therapiesNeeded?: TherapyNeeded | null
      therapies?: Array<Therapy | null> | null
      therapiesOtherComments?: string | null
      careWellOrganized?: CareWellOrganized | null
      organizationCareAdviceNeeded?: OrganizationCareAdviceNeeded | null
      organizationCareAdviceTopics?: string | null
      organizationCareAdviceComments?: string | null
      movingDifficulties?: MovingDifficulties | null
      movingDifficultiesActivity?: Array<MovingDifficultiesActivity | null> | null
      movingDifficultiesActivityOtherComments?: string | null
      sufficientMovingCare?: SufficientMovingCare | null
      fallenCareRecently?: FallenCareRecently | null
      generallyPhysicalActive?: GenerallyPhysicalActive | null
      mobilityAreaAdvice?: MobilityAreaAdvice | null
      mobilityAreaAdviceTopics?: string | null
      mobilityAreaAdviceComments?: string | null
      mentalDifficulties?: MentalDifficulties | null
      mentalDifficultiesList?: Array<MentalDifficultiesList | null> | null
      mentalDifficultiesListOtherComments?: string | null
      behaviorChanges?: BehaviorChanges | null
      behaviorChangesList?: Array<BehaviorChangesList | null> | null
      behaviorChangesListOtherComments?: string | null
      changesSupportNeeded?: ChangesSupportNeeded | null
      depressedRecently?: DepressedRecently | null
      lessEnjoyment?: LessEnjoyment | null
      mentalHealthCounseling?: MentalHealthCounseling | null
      mentalHealthCounselingTopics?: string | null
      mentalHealthCounselingComments?: string | null
      physicalProblems?: PhysicalProblems | null
      physicalProblemsList?: Array<PhysicalProblemsList | null> | null
      physicalProblemsListOtherComments?: string | null
      diseaseMeasures?: DiseaseMeasures | null
      diseaseMeasuresList?: Array<DiseaseMeasuresList | null> | null
      diseaseMeasuresListOtherComments?: string | null
      sufficientProblemsSupport?: SufficientProblemsSupport | null
      hospitalizedRecently?: HospitalizedRecently | null
      signsOfHealthRisk?: SignsOfHealthRisk | null
      signsOfHealthRiskList?: Array<SignsOfHealthRiskList | null> | null
      signsOfHealthRiskListSpecificRisksComments?: string | null
      physicalHealthAdvice?: PhysicalHealthAdvice | null
      physicalHealthAdviceTopics?: string | null
      physicalHealthAdviceComments?: string | null
      activitySupport?: ActivitySupport | null
      activitySupportList?: Array<ActivitySupportList | null> | null
      activitySupportListHygieneOtherComments?: string | null
      activitySupportListDressingOtherComments?: string | null
      activitySupportListNutritionOtherComments?: string | null
      activitySupportListExcretionOtherComments?: string | null
      activitySupportListHousekeepingOtherComments?: string | null
      sufficientActivitiesSupport?: SufficientActivitiesSupport | null
      selfSufficiencyAdvice?: SelfSufficiencyAdvice | null
      selfSufficiencyAdviceTopics?: string | null
      selfSufficiencyAdviceComments?: string | null
      socialContactDifficulties?: SocialContactDifficulties | null
      socialContactDifficultiesList?: Array<SocialContactDifficultiesList | null> | null
      socialContactDifficultiesListOtherComments?: string | null
      socialContactSupport?: SocialContactSupport | null
      socialContactAdvice?: SocialContactAdvice | null
      socialContactAdviceTopics?: string | null
      socialContactAdviceComments?: string | null
      livingEnvironmentProblems?: LivingEnvironmentProblems | null
      livingEnvironmentProblemsList?: Array<LivingEnvironmentProblemsList | null> | null
      livingEnvironmentProblemsListOtherComments?: string | null
      livingEnvironmentSupport?: LivingEnvironmentSupport | null
      livingEnvironmentAdvice?: LivingEnvironmentAdvice | null
      livingEnvironmentAdviceTopics?: string | null
      livingEnvironmentAdviceComments?: string | null
      relationshipIssues?: RelationshipIssues | null
      withRelativesIssues?: WithRelativesIssues | null
      withRelativesIssuesPersonInNeed?: WithRelativesIssuesPersonInNeed | null
      relativesRelationshipIssues?: RelativesRelationshipIssues | null
      relativesIssues?: RelativesIssues | null
      careIssues?: CareIssues | null
      careRelationshipAdvice?: CareRelationshipAdvice | null
      careRelationshipAdviceTopics?: string | null
      careRelationshipAdviceComments?: string | null
      careSituation?: CareSituation | null
      relativesCareDifficultiesList?: Array<RelativesCareDifficultiesList | null> | null
      relativesCareDifficultiesListOtherComments?: string | null
      relativesCareHelpFactorsList?: Array<RelativesCareHelpFactorsList | null> | null
      relativesCareHelpFactorsListOtherComments?: string | null
      relativesCareAdvice?: RelativesCareAdvice | null
      relativesCareAdviceTopics?: string | null
      relativesCareAdviceComments?: string | null
      diseaseMeasuresResponsible?: {
        __typename?: 'MeasureResponsible'
        medication?: Array<Responsible | null> | null
        medicationOtherComments?: string | null
        bodyConditionMonitoring?: Array<Responsible | null> | null
        bodyConditionMonitoringOtherComments?: string | null
        handlingBodyHuggingAids?: Array<Responsible | null> | null
        handlingBodyHuggingAidsOtherComments?: string | null
        dressingWoundsCare?: Array<Responsible | null> | null
        dressingWoundsCareOtherComments?: string | null
        therapy?: Array<Responsible | null> | null
        therapyOtherComments?: string | null
        doctorVisits?: Array<Responsible | null> | null
        doctorVisitsOtherComments?: string | null
        dietDueToIllness?: Array<Responsible | null> | null
        dietDueToIllnessOtherComments?: string | null
        other?: Array<Responsible | null> | null
        otherOtherComments?: string | null
      } | null
      activitySupportPerson?: {
        __typename?: 'ActivitySupportPerson'
        washUpperBody?: Array<Responsible | null> | null
        washUpperBodyOtherComments?: string | null
        combingShaving?: Array<Responsible | null> | null
        combingShavingOtherComments?: string | null
        oralCare?: Array<Responsible | null> | null
        oralCareOtherComments?: string | null
        washIntimateArea?: Array<Responsible | null> | null
        washIntimateAreaOtherComments?: string | null
        shower?: Array<Responsible | null> | null
        showerOtherComments?: string | null
        hairWash?: Array<Responsible | null> | null
        hairWashOtherComments?: string | null
        hygieneOther?: Array<Responsible | null> | null
        hygieneOtherOtherComments?: string | null
        dressingUpperBody?: Array<Responsible | null> | null
        dressingUpperBodyOtherComments?: string | null
        dressingLowerBody?: Array<Responsible | null> | null
        dressingLowerBodyOtherComments?: string | null
        dressingOther?: Array<Responsible | null> | null
        dressingOtherOtherComments?: string | null
        drink?: Array<Responsible | null> | null
        drinkOtherComments?: string | null
        eat?: Array<Responsible | null> | null
        eatOtherComments?: string | null
        nutritionOther?: Array<Responsible | null> | null
        nutritionOtherOtherComments?: string | null
        toilet?: Array<Responsible | null> | null
        toiletOtherComments?: string | null
        urinaryIncontinence?: Array<Responsible | null> | null
        urinaryIncontinenceOtherComments?: string | null
        fecalIncontinence?: Array<Responsible | null> | null
        fecalIncontinenceOtherComments?: string | null
        excretionOther?: Array<Responsible | null> | null
        excretionOtherOtherComments?: string | null
        shopping?: Array<Responsible | null> | null
        shoppingOtherComments?: string | null
        cooking?: Array<Responsible | null> | null
        cookingOtherComments?: string | null
        cleaning?: Array<Responsible | null> | null
        cleaningOtherComments?: string | null
        housekeepingOther?: Array<Responsible | null> | null
        housekeepingOtherOtherComments?: string | null
      } | null
    } | null
  } | null
}

export type AddAssessmentDetailMutationVariables = Exact<{
  rows:
    | Array<InputMaybe<AssessmentDetailInput>>
    | InputMaybe<AssessmentDetailInput>
}>

export type AddAssessmentDetailMutation = {
  __typename?: 'Mutation'
  assessmentDetailReplicate?: {
    __typename?: 'AssessmentDetailReplicatePayload'
    result?: Array<{
      __typename?: 'AssessmentDetail'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      reportingResponsible?: ReportingResponsible | null
      assistanceNeeded?: AssistanceNeeded | null
      assistances?: Array<Assistance | null> | null
      assistancesMobilityComments?: string | null
      assistancesPositioningInBedComments?: string | null
      assistancesPersonalHygieneComments?: string | null
      assistancesDevicesToSupportExcretionComments?: string | null
      assistancesPhysicalAidComments?: string | null
      assistancesDevicesToFoodIntakeComments?: string | null
      assistancesOtherComments?: string | null
      assistanceServicesNeeded?: AssistanceServiceNeeded | null
      assistanceServices?: Array<AssistanceService | null> | null
      assistanceServicesOtherComments?: string | null
      otherAssistancesNeeded?: OtherAssistanceNeeded | null
      otherAssistancesService?: Array<OtherAssistanceService | null> | null
      otherAssistancesServiceOtherComments?: string | null
      therapiesNeeded?: TherapyNeeded | null
      therapies?: Array<Therapy | null> | null
      therapiesOtherComments?: string | null
      careWellOrganized?: CareWellOrganized | null
      organizationCareAdviceNeeded?: OrganizationCareAdviceNeeded | null
      organizationCareAdviceTopics?: string | null
      organizationCareAdviceComments?: string | null
      movingDifficulties?: MovingDifficulties | null
      movingDifficultiesActivity?: Array<MovingDifficultiesActivity | null> | null
      movingDifficultiesActivityOtherComments?: string | null
      sufficientMovingCare?: SufficientMovingCare | null
      fallenCareRecently?: FallenCareRecently | null
      generallyPhysicalActive?: GenerallyPhysicalActive | null
      mobilityAreaAdvice?: MobilityAreaAdvice | null
      mobilityAreaAdviceTopics?: string | null
      mobilityAreaAdviceComments?: string | null
      mentalDifficulties?: MentalDifficulties | null
      mentalDifficultiesList?: Array<MentalDifficultiesList | null> | null
      mentalDifficultiesListOtherComments?: string | null
      behaviorChanges?: BehaviorChanges | null
      behaviorChangesList?: Array<BehaviorChangesList | null> | null
      behaviorChangesListOtherComments?: string | null
      changesSupportNeeded?: ChangesSupportNeeded | null
      depressedRecently?: DepressedRecently | null
      lessEnjoyment?: LessEnjoyment | null
      mentalHealthCounseling?: MentalHealthCounseling | null
      mentalHealthCounselingTopics?: string | null
      mentalHealthCounselingComments?: string | null
      physicalProblems?: PhysicalProblems | null
      physicalProblemsList?: Array<PhysicalProblemsList | null> | null
      physicalProblemsListOtherComments?: string | null
      diseaseMeasures?: DiseaseMeasures | null
      diseaseMeasuresList?: Array<DiseaseMeasuresList | null> | null
      diseaseMeasuresListOtherComments?: string | null
      sufficientProblemsSupport?: SufficientProblemsSupport | null
      hospitalizedRecently?: HospitalizedRecently | null
      signsOfHealthRisk?: SignsOfHealthRisk | null
      signsOfHealthRiskList?: Array<SignsOfHealthRiskList | null> | null
      signsOfHealthRiskListSpecificRisksComments?: string | null
      physicalHealthAdvice?: PhysicalHealthAdvice | null
      physicalHealthAdviceTopics?: string | null
      physicalHealthAdviceComments?: string | null
      activitySupport?: ActivitySupport | null
      activitySupportList?: Array<ActivitySupportList | null> | null
      activitySupportListHygieneOtherComments?: string | null
      activitySupportListDressingOtherComments?: string | null
      activitySupportListNutritionOtherComments?: string | null
      activitySupportListExcretionOtherComments?: string | null
      activitySupportListHousekeepingOtherComments?: string | null
      sufficientActivitiesSupport?: SufficientActivitiesSupport | null
      selfSufficiencyAdvice?: SelfSufficiencyAdvice | null
      selfSufficiencyAdviceTopics?: string | null
      selfSufficiencyAdviceComments?: string | null
      socialContactDifficulties?: SocialContactDifficulties | null
      socialContactDifficultiesList?: Array<SocialContactDifficultiesList | null> | null
      socialContactDifficultiesListOtherComments?: string | null
      socialContactSupport?: SocialContactSupport | null
      socialContactAdvice?: SocialContactAdvice | null
      socialContactAdviceTopics?: string | null
      socialContactAdviceComments?: string | null
      livingEnvironmentProblems?: LivingEnvironmentProblems | null
      livingEnvironmentProblemsList?: Array<LivingEnvironmentProblemsList | null> | null
      livingEnvironmentProblemsListOtherComments?: string | null
      livingEnvironmentSupport?: LivingEnvironmentSupport | null
      livingEnvironmentAdvice?: LivingEnvironmentAdvice | null
      livingEnvironmentAdviceTopics?: string | null
      livingEnvironmentAdviceComments?: string | null
      relationshipIssues?: RelationshipIssues | null
      withRelativesIssues?: WithRelativesIssues | null
      withRelativesIssuesPersonInNeed?: WithRelativesIssuesPersonInNeed | null
      relativesRelationshipIssues?: RelativesRelationshipIssues | null
      relativesIssues?: RelativesIssues | null
      careIssues?: CareIssues | null
      careRelationshipAdvice?: CareRelationshipAdvice | null
      careRelationshipAdviceTopics?: string | null
      careRelationshipAdviceComments?: string | null
      careSituation?: CareSituation | null
      relativesCareDifficultiesList?: Array<RelativesCareDifficultiesList | null> | null
      relativesCareDifficultiesListOtherComments?: string | null
      relativesCareHelpFactorsList?: Array<RelativesCareHelpFactorsList | null> | null
      relativesCareHelpFactorsListOtherComments?: string | null
      relativesCareAdvice?: RelativesCareAdvice | null
      relativesCareAdviceTopics?: string | null
      relativesCareAdviceComments?: string | null
      diseaseMeasuresResponsible?: {
        __typename?: 'MeasureResponsible'
        medication?: Array<Responsible | null> | null
        medicationOtherComments?: string | null
        bodyConditionMonitoring?: Array<Responsible | null> | null
        bodyConditionMonitoringOtherComments?: string | null
        handlingBodyHuggingAids?: Array<Responsible | null> | null
        handlingBodyHuggingAidsOtherComments?: string | null
        dressingWoundsCare?: Array<Responsible | null> | null
        dressingWoundsCareOtherComments?: string | null
        therapy?: Array<Responsible | null> | null
        therapyOtherComments?: string | null
        doctorVisits?: Array<Responsible | null> | null
        doctorVisitsOtherComments?: string | null
        dietDueToIllness?: Array<Responsible | null> | null
        dietDueToIllnessOtherComments?: string | null
        other?: Array<Responsible | null> | null
        otherOtherComments?: string | null
      } | null
      activitySupportPerson?: {
        __typename?: 'ActivitySupportPerson'
        washUpperBody?: Array<Responsible | null> | null
        washUpperBodyOtherComments?: string | null
        combingShaving?: Array<Responsible | null> | null
        combingShavingOtherComments?: string | null
        oralCare?: Array<Responsible | null> | null
        oralCareOtherComments?: string | null
        washIntimateArea?: Array<Responsible | null> | null
        washIntimateAreaOtherComments?: string | null
        shower?: Array<Responsible | null> | null
        showerOtherComments?: string | null
        hairWash?: Array<Responsible | null> | null
        hairWashOtherComments?: string | null
        hygieneOther?: Array<Responsible | null> | null
        hygieneOtherOtherComments?: string | null
        dressingUpperBody?: Array<Responsible | null> | null
        dressingUpperBodyOtherComments?: string | null
        dressingLowerBody?: Array<Responsible | null> | null
        dressingLowerBodyOtherComments?: string | null
        dressingOther?: Array<Responsible | null> | null
        dressingOtherOtherComments?: string | null
        drink?: Array<Responsible | null> | null
        drinkOtherComments?: string | null
        eat?: Array<Responsible | null> | null
        eatOtherComments?: string | null
        nutritionOther?: Array<Responsible | null> | null
        nutritionOtherOtherComments?: string | null
        toilet?: Array<Responsible | null> | null
        toiletOtherComments?: string | null
        urinaryIncontinence?: Array<Responsible | null> | null
        urinaryIncontinenceOtherComments?: string | null
        fecalIncontinence?: Array<Responsible | null> | null
        fecalIncontinenceOtherComments?: string | null
        excretionOther?: Array<Responsible | null> | null
        excretionOtherOtherComments?: string | null
        shopping?: Array<Responsible | null> | null
        shoppingOtherComments?: string | null
        cooking?: Array<Responsible | null> | null
        cookingOtherComments?: string | null
        cleaning?: Array<Responsible | null> | null
        cleaningOtherComments?: string | null
        housekeepingOther?: Array<Responsible | null> | null
        housekeepingOtherOtherComments?: string | null
      } | null
    } | null> | null
  } | null
}

export type AssessmentMeasurementFragment = {
  __typename?: 'AssessmentMeasurement'
  rowId: any
  updatedAt: any
  deleted: boolean
  assessmentId?: any | null
  organization?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  mobility?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  mentalHealth?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  physicalHealth?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  selfSufficiency?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  socialContacts?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  livingEnvironment?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  careRelationship?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
  relativeSituation?: {
    __typename?: 'MeasurementField'
    arrayValues?: Array<{
      __typename?: 'ArrayField'
      fieldName?: string | null
      value?: Array<string | null> | null
    } | null> | null
    stringValues?: Array<{
      __typename?: 'StringField'
      fieldName?: string | null
      value?: string | null
    } | null> | null
  } | null
}

export type AssessmentMeasurementDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssessmentMeasurementDocumentsQuery = {
  __typename?: 'Query'
  assessmentMeasurementDocuments?: {
    __typename?: 'AssessmentMeasurementConnection'
    nodes: Array<{
      __typename?: 'AssessmentMeasurement'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      organization?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mobility?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mentalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      physicalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      selfSufficiency?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      socialContacts?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      livingEnvironment?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      careRelationship?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      relativeSituation?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
    } | null>
  } | null
}

export type StreamAssessmentMeasurementsSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssessmentMeasurementsSubscription = {
  __typename?: 'Subscription'
  streamAssessmentMeasurements?: {
    __typename?: 'AssessmentMeasurementSubscriptionPayload'
    assessmentMeasurement?: {
      __typename?: 'AssessmentMeasurement'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      organization?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mobility?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mentalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      physicalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      selfSufficiency?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      socialContacts?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      livingEnvironment?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      careRelationship?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      relativeSituation?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type AddAssessmentMeasurementMutationVariables = Exact<{
  rows:
    | Array<InputMaybe<AssessmentMeasurementInput>>
    | InputMaybe<AssessmentMeasurementInput>
}>

export type AddAssessmentMeasurementMutation = {
  __typename?: 'Mutation'
  assessmentMeasurementReplicate?: {
    __typename?: 'AssessmentMeasurementReplicatePayload'
    result?: Array<{
      __typename?: 'AssessmentMeasurement'
      rowId: any
      updatedAt: any
      deleted: boolean
      assessmentId?: any | null
      organization?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mobility?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      mentalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      physicalHealth?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      selfSufficiency?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      socialContacts?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      livingEnvironment?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      careRelationship?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
      relativeSituation?: {
        __typename?: 'MeasurementField'
        arrayValues?: Array<{
          __typename?: 'ArrayField'
          fieldName?: string | null
          value?: Array<string | null> | null
        } | null> | null
        stringValues?: Array<{
          __typename?: 'StringField'
          fieldName?: string | null
          value?: string | null
        } | null> | null
      } | null
    } | null> | null
  } | null
}

export type AssessmentSignatureFragment = {
  __typename?: 'AssessmentSignature'
  rowId: any
  assessmentId?: any | null
  signatureConfirmPartnerMediation?: string | null
  signatureConfirmProtocol?: string | null
  signatureSection37CareRecipient?: string | null
  signatureSection37Counselor?: string | null
  signatureSection37Caregiver?: string | null
  signatureSection45BillingPerson?: string | null
  signatureSection45Caregiver?: string | null
  updatedAt: any
  deleted: boolean
}

export type StreamAssessmentSignaturesSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssessmentSignaturesSubscription = {
  __typename?: 'Subscription'
  streamAssessmentSignatures?: {
    __typename?: 'AssessmentSignatureSubscriptionPayload'
    assessmentSignature?: {
      __typename?: 'AssessmentSignature'
      rowId: any
      assessmentId?: any | null
      signatureConfirmPartnerMediation?: string | null
      signatureConfirmProtocol?: string | null
      signatureSection37CareRecipient?: string | null
      signatureSection37Counselor?: string | null
      signatureSection37Caregiver?: string | null
      signatureSection45BillingPerson?: string | null
      signatureSection45Caregiver?: string | null
      updatedAt: any
      deleted: boolean
    } | null
  } | null
}

export type AssessmentSignatureDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssessmentSignatureDocumentsQuery = {
  __typename?: 'Query'
  assessmentSignatureDocuments?: {
    __typename?: 'AssessmentSignatureConnection'
    nodes: Array<{
      __typename?: 'AssessmentSignature'
      rowId: any
      assessmentId?: any | null
      signatureConfirmPartnerMediation?: string | null
      signatureConfirmProtocol?: string | null
      signatureSection37CareRecipient?: string | null
      signatureSection37Counselor?: string | null
      signatureSection37Caregiver?: string | null
      signatureSection45BillingPerson?: string | null
      signatureSection45Caregiver?: string | null
      updatedAt: any
      deleted: boolean
    } | null>
  } | null
}

export type AssessmentSignatureReplicateMutationVariables = Exact<{
  rows:
    | Array<InputMaybe<AssessmentSignatureInput>>
    | InputMaybe<AssessmentSignatureInput>
}>

export type AssessmentSignatureReplicateMutation = {
  __typename?: 'Mutation'
  assessmentSignatureReplicate?: {
    __typename?: 'AssessmentSignatureReplicatePayload'
    result?: Array<{
      __typename?: 'AssessmentSignature'
      rowId: any
      assessmentId?: any | null
      signatureConfirmPartnerMediation?: string | null
      signatureConfirmProtocol?: string | null
      signatureSection37CareRecipient?: string | null
      signatureSection37Counselor?: string | null
      signatureSection37Caregiver?: string | null
      signatureSection45BillingPerson?: string | null
      signatureSection45Caregiver?: string | null
      updatedAt: any
      deleted: boolean
    } | null> | null
  } | null
}

export type AssignmentFragment = {
  __typename?: 'Assignment'
  rowId: any
  appointmentAt: any
  appUserId: any
  updatedAt: any
  deleted: boolean
}

export type StreamAssignmentsSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type StreamAssignmentsSubscription = {
  __typename?: 'Subscription'
  streamAssignments?: {
    __typename?: 'AssignmentSubscriptionPayload'
    assignment?: {
      __typename?: 'Assignment'
      rowId: any
      appointmentAt: any
      appUserId: any
      updatedAt: any
      deleted: boolean
    } | null
  } | null
}

export type AssignmentDocumentsQueryVariables = Exact<{
  checkpoint?: InputMaybe<DocumentCheckpointInput>
  first: Scalars['Int']['input']
}>

export type AssignmentDocumentsQuery = {
  __typename?: 'Query'
  assignmentDocuments?: {
    __typename?: 'AssignmentConnection'
    nodes: Array<{
      __typename?: 'Assignment'
      rowId: any
      appointmentAt: any
      appUserId: any
      updatedAt: any
      deleted: boolean
    } | null>
  } | null
}

export const AssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReasonOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientGender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientSurname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientBirthdayAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientHasCareLevel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careServiceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientCareLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientCareLevelNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientFinancialSituation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'houseNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientPhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientDiseases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationBeginAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationEndAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipants' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipantsOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPartner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterSon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterInLawSonInLaw' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGrandchild' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactParent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactFriend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNeighbor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSupervisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGeneralPractitioner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSpecialistDoctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNursingService' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactOther' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportWithCare' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportWithCareOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caregiverRegistered' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'medicalTreatment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeFormOther' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orders' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relevantContacts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relevantContactsOther' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssessmentFragment, unknown>
export const AssessmentAdditionalInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentAdditionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentAdditionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsPersonInNeedOfCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsRelativeCaregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'agreedObjectives' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementsOnNextSteps' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'openQuestions' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCaregiverPerspective',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCounselorPerspective',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportIsEnsured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportIsEnsuredReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportSituationImproveMeasures' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestions',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestionsOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counselingViaVideoConference' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingIndicatedSection7A' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingRequestedSection7A' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareCareSupportInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareImprovementRecommendations',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToSiteInspectionAndToShareInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingCounselingResultsSection7A',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingByInsuranceSection45',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationAndDateSection373' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocolDispatch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'protocolDispatchEmail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'trainingSubject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billablePerson' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssessmentAdditionalInfoFragment, unknown>
export const AssessmentDetailFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentDetail' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentDetail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportingResponsible' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistanceNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assistances' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesMobilityComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesPositioningInBedComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPersonalHygieneComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToSupportExcretionComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPhysicalAidComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToFoodIntakeComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServices' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesService' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'otherAssistancesServiceOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'therapiesNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'therapies' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'therapiesOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careWellOrganized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficultiesActivity' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'movingDifficultiesActivityOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientMovingCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fallenCareRecently' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generallyPhysicalActive' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'mentalDifficultiesListOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorChanges' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changesSupportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'depressedRecently' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lessEnjoyment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounseling' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalProblems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsListOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'diseaseMeasures' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresResponsible' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medication' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'medicationOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyConditionMonitoring' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'bodyConditionMonitoringOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'handlingBodyHuggingAids' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'handlingBodyHuggingAidsOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingWoundsCare' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingWoundsCareOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'therapy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'therapyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisits' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisitsOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dietDueToIllness' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dietDueToIllnessOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherOtherComments' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientProblemsSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hospitalizedRecently' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'signsOfHealthRisk' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signsOfHealthRiskList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'signsOfHealthRiskListSpecificRisksComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activitySupport' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHygieneOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListDressingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListNutritionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListExcretionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHousekeepingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportPerson' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBody' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBodyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShaving' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShavingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'oralCare' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'oralCareOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washIntimateArea' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'washIntimateAreaOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shower' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showerOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hairWash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hairWashOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOtherOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingUpperBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingUpperBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingLowerBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingLowerBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'drink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drinkOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eatOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'toilet' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'toiletOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'urinaryIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'urinaryIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fecalIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'fecalIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shopping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shoppingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cooking' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cookingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cleaning' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cleaningOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'housekeepingOther' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'housekeepingOtherOtherComments',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientActivitiesSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'socialContactDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblems' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblemsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'livingEnvironmentProblemsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relationshipIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssuesPersonInNeed' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesRelationshipIssues' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'relativesIssues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'careIssues' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careSituation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareHelpFactorsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareHelpFactorsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceComments' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssessmentDetailFragment, unknown>
export const AssessmentMeasurementFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentMeasurement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativeSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssessmentMeasurementFragment, unknown>
export const AssessmentSignatureFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentSignature' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentSignature' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmPartnerMediation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmProtocol' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37CareRecipient' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Counselor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Caregiver' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45BillingPerson' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45Caregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssessmentSignatureFragment, unknown>
export const AssignmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assignment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assignment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentFragment, unknown>
export const AppUserDocumentsDocument = {
  __meta__: { hash: '03b021981dd3ba7cdc5501dc042a09d79e41963e' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appUserDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appUserDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'emailAddress' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppUserDocumentsQuery,
  AppUserDocumentsQueryVariables
>
export const AssessmentDocumentsDocument = {
  __meta__: { hash: '47ed49d382f72c959621f4fae6b9789194f45a6c' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assessmentDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReasonOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientGender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientSurname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientBirthdayAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientHasCareLevel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careServiceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientCareLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientCareLevelNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientFinancialSituation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'houseNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientPhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientDiseases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationBeginAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationEndAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipants' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipantsOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPartner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterSon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterInLawSonInLaw' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGrandchild' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactParent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactFriend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNeighbor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSupervisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGeneralPractitioner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSpecialistDoctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNursingService' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactOther' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportWithCare' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportWithCareOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caregiverRegistered' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'medicalTreatment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeFormOther' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orders' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relevantContacts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relevantContactsOther' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentDocumentsQuery,
  AssessmentDocumentsQueryVariables
>
export const StreamAssessmentDocument = {
  __meta__: { hash: '30cd0aaf7c006b026dc813a0f5bcb728ab0af4a0' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssessment' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssessments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReasonOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientGender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientSurname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientBirthdayAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientHasCareLevel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careServiceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientCareLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientCareLevelNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientFinancialSituation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'houseNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientPhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientDiseases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationBeginAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationEndAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipants' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipantsOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPartner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterSon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterInLawSonInLaw' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGrandchild' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactParent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactFriend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNeighbor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSupervisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGeneralPractitioner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSpecialistDoctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNursingService' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactOther' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportWithCare' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportWithCareOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caregiverRegistered' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'medicalTreatment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeFormOther' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orders' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relevantContacts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relevantContactsOther' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssessmentSubscription,
  StreamAssessmentSubscriptionVariables
>
export const AddAssessmentDocument = {
  __meta__: { hash: '8b45b3a9597409128d98bbd9c6f9a63a6e587160' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addAssessment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rows' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AssessmentInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentReplicate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rows' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationReasonOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientInsuranceType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientGender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientSurname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientBirthdayAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientHasCareLevel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careServiceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientCareLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientCareLevelNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientFinancialSituation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'houseNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patientPhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'patientDiseases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationBeginAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'consultationEndAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipants' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultationParticipantsOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPartner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterSon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactDaughterInLawSonInLaw' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGrandchild' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactParent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactFriend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNeighbor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSupervisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactGeneralPractitioner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactSpecialistDoctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNursingService' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactOther' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceFund' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'healthInsuranceType' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportWithCare' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportWithCareOther' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caregiverRegistered' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'medicalTreatment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lifeFormOther' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orders' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relevantContacts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relevantContactsOther' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAssessmentMutation,
  AddAssessmentMutationVariables
>
export const AssessmentAdditionalInfoDocumentsDocument = {
  __meta__: { hash: '7bffdafc686ca4a1fdb604a505cfa276c8b6379b' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assessmentAdditionalInfoDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentAdditionalInfoDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'assessmentAdditionalInfo',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentAdditionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentAdditionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsPersonInNeedOfCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsRelativeCaregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'agreedObjectives' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementsOnNextSteps' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'openQuestions' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCaregiverPerspective',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCounselorPerspective',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportIsEnsured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportIsEnsuredReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportSituationImproveMeasures' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestions',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestionsOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counselingViaVideoConference' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingIndicatedSection7A' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingRequestedSection7A' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareCareSupportInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareImprovementRecommendations',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToSiteInspectionAndToShareInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingCounselingResultsSection7A',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingByInsuranceSection45',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationAndDateSection373' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocolDispatch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'protocolDispatchEmail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'trainingSubject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billablePerson' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentAdditionalInfoDocumentsQuery,
  AssessmentAdditionalInfoDocumentsQueryVariables
>
export const StreamAssessmentAdditionalInfosDocument = {
  __meta__: { hash: '352d02b86f9e4fe8adebfb585d50ae743bb7c86b' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssessmentAdditionalInfos' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssessmentAdditionalInfos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentAdditionalInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'assessmentAdditionalInfo',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentAdditionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentAdditionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsPersonInNeedOfCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsRelativeCaregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'agreedObjectives' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementsOnNextSteps' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'openQuestions' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCaregiverPerspective',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCounselorPerspective',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportIsEnsured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportIsEnsuredReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportSituationImproveMeasures' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestions',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestionsOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counselingViaVideoConference' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingIndicatedSection7A' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingRequestedSection7A' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareCareSupportInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareImprovementRecommendations',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToSiteInspectionAndToShareInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingCounselingResultsSection7A',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingByInsuranceSection45',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationAndDateSection373' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocolDispatch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'protocolDispatchEmail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'trainingSubject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billablePerson' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssessmentAdditionalInfosSubscription,
  StreamAssessmentAdditionalInfosSubscriptionVariables
>
export const AddAssessmentAdditionalInfoDocument = {
  __meta__: { hash: 'e644366987faa8d8b4935be290705280e3149759' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addAssessmentAdditionalInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rows' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AssessmentAdditionalInfoInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentAdditionalInfoReplicate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rows' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'assessmentAdditionalInfo',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentAdditionalInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentAdditionalInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careChangesSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'careImprovementsSuggestionsRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualPersonInNeedOfCare',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'differentThanUsualRelativeCaregiver',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsPersonInNeedOfCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherCommentsRelativeCaregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'agreedObjectives' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementsOnNextSteps' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'openQuestions' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCaregiverPerspective',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationCounselorPerspective',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supportIsEnsured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportIsEnsuredReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportSituationImproveMeasures' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestions',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'supportSituationImproveMeasuresSuggestionsOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counselingViaVideoConference' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingIndicatedSection7A' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careCounselingRequestedSection7A' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareCareSupportInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToShareImprovementRecommendations',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToSiteInspectionAndToShareInformation',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingCounselingResultsSection7A',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'consentToProcessingByInsuranceSection45',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationAndDateSection373' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'protocolDispatch' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'protocolDispatchEmail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'trainingSubject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billablePerson' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAssessmentAdditionalInfoMutation,
  AddAssessmentAdditionalInfoMutationVariables
>
export const AssessmentDetailDocumentsDocument = {
  __meta__: { hash: 'f7b7589b6ae3ce15f06b7cd271b8aa371c448677' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assessmentDetailDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentDetailDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentDetail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentDetail' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentDetail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportingResponsible' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistanceNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assistances' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesMobilityComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesPositioningInBedComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPersonalHygieneComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToSupportExcretionComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPhysicalAidComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToFoodIntakeComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServices' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesService' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'otherAssistancesServiceOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'therapiesNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'therapies' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'therapiesOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careWellOrganized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficultiesActivity' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'movingDifficultiesActivityOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientMovingCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fallenCareRecently' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generallyPhysicalActive' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'mentalDifficultiesListOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorChanges' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changesSupportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'depressedRecently' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lessEnjoyment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounseling' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalProblems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsListOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'diseaseMeasures' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresResponsible' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medication' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'medicationOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyConditionMonitoring' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'bodyConditionMonitoringOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'handlingBodyHuggingAids' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'handlingBodyHuggingAidsOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingWoundsCare' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingWoundsCareOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'therapy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'therapyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisits' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisitsOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dietDueToIllness' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dietDueToIllnessOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherOtherComments' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientProblemsSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hospitalizedRecently' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'signsOfHealthRisk' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signsOfHealthRiskList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'signsOfHealthRiskListSpecificRisksComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activitySupport' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHygieneOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListDressingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListNutritionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListExcretionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHousekeepingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportPerson' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBody' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBodyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShaving' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShavingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'oralCare' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'oralCareOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washIntimateArea' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'washIntimateAreaOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shower' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showerOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hairWash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hairWashOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOtherOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingUpperBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingUpperBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingLowerBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingLowerBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'drink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drinkOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eatOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'toilet' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'toiletOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'urinaryIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'urinaryIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fecalIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'fecalIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shopping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shoppingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cooking' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cookingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cleaning' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cleaningOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'housekeepingOther' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'housekeepingOtherOtherComments',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientActivitiesSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'socialContactDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblems' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblemsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'livingEnvironmentProblemsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relationshipIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssuesPersonInNeed' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesRelationshipIssues' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'relativesIssues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'careIssues' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careSituation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareHelpFactorsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareHelpFactorsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceComments' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentDetailDocumentsQuery,
  AssessmentDetailDocumentsQueryVariables
>
export const StreamAssessmentDetailsDocument = {
  __meta__: { hash: '9d751411521b6a7ccb51e0e25b13ca44e8fa8f81' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssessmentDetails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssessmentDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentDetail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentDetail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentDetail' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentDetail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportingResponsible' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistanceNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assistances' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesMobilityComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesPositioningInBedComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPersonalHygieneComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToSupportExcretionComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPhysicalAidComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToFoodIntakeComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServices' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesService' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'otherAssistancesServiceOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'therapiesNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'therapies' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'therapiesOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careWellOrganized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficultiesActivity' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'movingDifficultiesActivityOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientMovingCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fallenCareRecently' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generallyPhysicalActive' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'mentalDifficultiesListOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorChanges' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changesSupportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'depressedRecently' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lessEnjoyment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounseling' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalProblems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsListOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'diseaseMeasures' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresResponsible' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medication' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'medicationOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyConditionMonitoring' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'bodyConditionMonitoringOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'handlingBodyHuggingAids' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'handlingBodyHuggingAidsOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingWoundsCare' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingWoundsCareOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'therapy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'therapyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisits' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisitsOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dietDueToIllness' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dietDueToIllnessOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherOtherComments' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientProblemsSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hospitalizedRecently' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'signsOfHealthRisk' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signsOfHealthRiskList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'signsOfHealthRiskListSpecificRisksComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activitySupport' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHygieneOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListDressingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListNutritionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListExcretionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHousekeepingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportPerson' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBody' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBodyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShaving' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShavingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'oralCare' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'oralCareOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washIntimateArea' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'washIntimateAreaOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shower' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showerOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hairWash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hairWashOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOtherOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingUpperBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingUpperBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingLowerBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingLowerBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'drink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drinkOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eatOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'toilet' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'toiletOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'urinaryIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'urinaryIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fecalIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'fecalIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shopping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shoppingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cooking' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cookingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cleaning' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cleaningOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'housekeepingOther' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'housekeepingOtherOtherComments',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientActivitiesSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'socialContactDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblems' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblemsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'livingEnvironmentProblemsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relationshipIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssuesPersonInNeed' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesRelationshipIssues' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'relativesIssues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'careIssues' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careSituation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareHelpFactorsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareHelpFactorsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceComments' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssessmentDetailsSubscription,
  StreamAssessmentDetailsSubscriptionVariables
>
export const AddAssessmentDetailDocument = {
  __meta__: { hash: 'a9e33f2efaec63a031dc7134558857de07fed178' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addAssessmentDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rows' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AssessmentDetailInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentDetailReplicate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rows' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentDetail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentDetail' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentDetail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportingResponsible' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistanceNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assistances' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesMobilityComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesPositioningInBedComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPersonalHygieneComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToSupportExcretionComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesPhysicalAidComments' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'assistancesDevicesToFoodIntakeComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistancesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServices' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assistanceServicesOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherAssistancesService' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'otherAssistancesServiceOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'therapiesNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'therapies' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'therapiesOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careWellOrganized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceNeeded' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationCareAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'movingDifficultiesActivity' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'movingDifficultiesActivityOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientMovingCare' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fallenCareRecently' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generallyPhysicalActive' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilityAreaAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'mentalDifficultiesListOtherComments',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'behaviorChanges' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'behaviorChangesListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changesSupportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'depressedRecently' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lessEnjoyment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounseling' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealthCounselingComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalProblems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalProblemsListOtherComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'diseaseMeasures' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresList' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresListOtherComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diseaseMeasuresResponsible' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medication' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'medicationOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyConditionMonitoring' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'bodyConditionMonitoringOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'handlingBodyHuggingAids' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'handlingBodyHuggingAidsOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingWoundsCare' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingWoundsCareOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'therapy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'therapyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisits' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'doctorVisitsOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dietDueToIllness' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dietDueToIllnessOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherOtherComments' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientProblemsSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hospitalizedRecently' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'signsOfHealthRisk' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signsOfHealthRiskList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'signsOfHealthRiskListSpecificRisksComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealthAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activitySupport' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHygieneOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListDressingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListNutritionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListExcretionOtherComments',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'activitySupportListHousekeepingOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activitySupportPerson' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBody' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washUpperBodyOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShaving' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combingShavingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'oralCare' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'oralCareOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'washIntimateArea' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'washIntimateAreaOtherComments',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shower' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showerOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hairWash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hairWashOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hygieneOtherOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingUpperBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingUpperBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingLowerBody' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'dressingLowerBodyOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dressingOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'drink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drinkOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eatOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nutritionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'toilet' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'toiletOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'urinaryIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'urinaryIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fecalIncontinence' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'fecalIncontinenceOtherComments',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOther' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excretionOtherOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shopping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shoppingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cooking' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cookingOtherComments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cleaning' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cleaningOtherComments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'housekeepingOther' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'housekeepingOtherOtherComments',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sufficientActivitiesSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiencyAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficulties' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'socialContactDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContactAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblems' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentProblemsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'livingEnvironmentProblemsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentSupport' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironmentAdviceComments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relationshipIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssues' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'withRelativesIssuesPersonInNeed' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesRelationshipIssues' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'relativesIssues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'careIssues' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationshipAdviceComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'careSituation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareDifficultiesList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareDifficultiesListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareHelpFactorsList' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'relativesCareHelpFactorsListOtherComments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdvice' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceTopics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativesCareAdviceComments' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAssessmentDetailMutation,
  AddAssessmentDetailMutationVariables
>
export const AssessmentMeasurementDocumentsDocument = {
  __meta__: { hash: '34740fac8fe79e95a989fd6da9552d139b92f789' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assessmentMeasurementDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentMeasurementDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentMeasurement' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentMeasurement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativeSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentMeasurementDocumentsQuery,
  AssessmentMeasurementDocumentsQueryVariables
>
export const StreamAssessmentMeasurementsDocument = {
  __meta__: { hash: '44f5035d0e3c71a1888d75d9fc44d2665f74c956' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssessmentMeasurements' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssessmentMeasurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentMeasurement' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentMeasurement' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentMeasurement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativeSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssessmentMeasurementsSubscription,
  StreamAssessmentMeasurementsSubscriptionVariables
>
export const AddAssessmentMeasurementDocument = {
  __meta__: { hash: '7b1c92adf06dae3ae6c54e5521cecfb14f6880c9' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addAssessmentMeasurement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rows' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AssessmentMeasurementInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentMeasurementReplicate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rows' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentMeasurement' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentMeasurement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'physicalHealth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selfSufficiency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livingEnvironment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careRelationship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relativeSituation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrayValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stringValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAssessmentMeasurementMutation,
  AddAssessmentMeasurementMutationVariables
>
export const StreamAssessmentSignaturesDocument = {
  __meta__: { hash: '34c8fc0aabeaf481c3be3f98112a8e01dc96d6e5' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssessmentSignatures' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssessmentSignatures' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentSignature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentSignature' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentSignature' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentSignature' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmPartnerMediation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmProtocol' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37CareRecipient' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Counselor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Caregiver' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45BillingPerson' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45Caregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssessmentSignaturesSubscription,
  StreamAssessmentSignaturesSubscriptionVariables
>
export const AssessmentSignatureDocumentsDocument = {
  __meta__: { hash: 'ed79d6b3a5e5198c53748e24c7d14269809a5773' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assessmentSignatureDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentSignatureDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentSignature' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentSignature' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentSignature' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmPartnerMediation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmProtocol' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37CareRecipient' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Counselor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Caregiver' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45BillingPerson' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45Caregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentSignatureDocumentsQuery,
  AssessmentSignatureDocumentsQueryVariables
>
export const AssessmentSignatureReplicateDocument = {
  __meta__: { hash: '5b25913306d1409b667e61ca34c6be546aa1652d' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assessmentSignatureReplicate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rows' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AssessmentSignatureInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentSignatureReplicate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rows' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assessmentSignature' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assessmentSignature' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentSignature' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmPartnerMediation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureConfirmProtocol' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37CareRecipient' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Counselor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection37Caregiver' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45BillingPerson' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signatureSection45Caregiver' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssessmentSignatureReplicateMutation,
  AssessmentSignatureReplicateMutationVariables
>
export const StreamAssignmentsDocument = {
  __meta__: { hash: 'ba768be8b258963f87d9a031932ae8d3978d41e1' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'streamAssignments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'streamAssignments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assignment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assignment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assignment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamAssignmentsSubscription,
  StreamAssignmentsSubscriptionVariables
>
export const AssignmentDocumentsDocument = {
  __meta__: { hash: 'deb56bac2f634b3bb6c2da277392a9c7fd41cd1e' },
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assignmentDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkpoint' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentCheckpointInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkpoint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkpoint' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'assignment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assignment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Assignment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignmentDocumentsQuery,
  AssignmentDocumentsQueryVariables
>
